const hu = {
  'common.loading': 'Betöltés…',
  'common.save': 'Mentés',
  'common.saving': 'Mentés…',
  'common.cancel': 'Mégse',
  'common.delete': 'Törlés',
  'common.search': 'Keresés',
  'common.sortBy': 'Rendezés',
  'common.never': 'Soha',
  'common.justNow': 'Éppen most',
  'common.accessDenied': 'Hozzáférés megtagadva',
  'common.backToLogin': 'Vissza a bejelentkezéshez',
  'common.markAsRead': 'Megjelölés olvasottként',
  'common.user': 'Felhasználó',
  'shell.supportDesk': 'Támogatási központ',
  'shell.searchPlaceholder': 'Jegyek, kapcsolatok, cikkek keresése…',
  'shell.newTicket': 'Új jegy',
  'shell.notifications': 'Értesítések',
  'shell.notificationPreferences': 'Értesítési beállítások',
  'shell.settings': 'Beállítások',
  'shell.signOut': 'Kijelentkezés',
  'shell.expandNavigation': 'Navigáció kibontása',
  'shell.collapseNavigation': 'Navigáció összecsukása',
  'shell.adminNavigation': 'Adminisztrációs navigáció',
  'shell.caughtUp': 'Minden naprakész',
  'shell.viewAllNotifications': 'Összes értesítés megtekintése',
  'nav.dashboard': 'Irányítópult',
  'nav.tickets': 'Jegyek',
  'nav.contacts': 'Kapcsolatok',
  'nav.companies': 'Vállalatok',
  'nav.reports': 'Jelentések',
  'nav.settings': 'Beállítások',
  'nav.agents': 'Ügynökök',
  'nav.groups': 'Csoportok',
  'nav.roles': 'Szerepkörök',
  'nav.tags': 'Címkék',
  'nav.ticketFields': 'Jegymezők',
  'nav.ticketForms': 'Jegyűrlapok',
  'nav.businessHours': 'Munkaidő',
  'nav.slaPolicies': 'SLA-szabályzatok',
  'nav.automations': 'Automatizálások',
  'nav.email': 'E-mail',
  'nav.notificationTemplates': 'Értesítési sablonok',
  'nav.apiKeys': 'API-kulcsok',
  'nav.cannedResponses': 'Mentett válaszok',
  'nav.knowledgeBase': 'Tudásbázis',
  'auth.signInTitle': 'SDPL támogatási központ',
  'auth.signInSubtitle': 'Jelentkezzen be a fiókjába',
  'auth.emailAddress': 'E-mail-cím',
  'auth.password': 'Jelszó',
  'auth.signingIn': 'Bejelentkezés…',
  'auth.signIn': 'Bejelentkezés',
  'auth.forgotPassword': 'Elfelejtette a jelszavát?',
  'auth.twoFactor': 'Kétfaktoros hitelesítés',
  'auth.verificationCode': 'Ellenőrző kód',
  'auth.verify': 'Ellenőrzés',
  'auth.backToLogin': 'Vissza a bejelentkezéshez',
  'agents.title': 'Ügynökök',
  'agents.new': 'Új ügynök',
  'agents.supportAgents': 'Támogatási ügynökök',
  'agents.collaborators': 'Közreműködők',
  'agents.deactivated': 'Inaktiváltak',
  'agents.searchPlaceholder': 'Keresés név vagy e-mail alapján',
  'agents.noSearchResults': 'Nincs a keresésnek megfelelő ügynök',
  'agents.noAgentsView': 'Nincs ügynök ebben a nézetben',
  'agents.edit': 'Szerkesztés',
  'agents.deactivate': 'Inaktiválás',
  'agents.reactivate': 'Újraaktiválás',
  'agents.saved': 'Ügynök mentve.',
  'agents.firstName': 'Keresztnév',
  'agents.lastName': 'Vezetéknév',
  'agents.email': 'E-mail',
  'agents.phone': 'Telefon',
  'agents.timezone': 'Időzóna',
  'agents.selectTimezone': 'Időzóna kiválasztása',
  'agents.language': 'Nyelv',
  'agents.selectLanguage': 'Nyelv kiválasztása',
  'agents.emailSignature': 'E-mail-aláírás',
  'agents.roleRequired': 'Szerepkör',
  'agents.selectRole': 'Szerepkör kiválasztása',
  'agents.status': 'Állapot',
  'agents.groupsTitle': 'Csoportok',
  'agents.manageGroups': 'Csoportok kezelése',
  'agents.notInGroup': 'Még nincs csoportban',
  'dashboard.title': 'Irányítópult',
  'dashboard.description': 'Aktuális támogatási terhelés és szolgáltatási állapot.',
  'dashboard.allGroups': 'Minden elérhető csoport',
  'dashboard.unresolved': 'Megoldatlan',
  'dashboard.overdue': 'Lejárt',
  'dashboard.dueToday': 'Ma esedékes',
  'dashboard.open': 'Nyitott',
  'dashboard.onHold': 'Függőben',
  'dashboard.unassigned': 'Nincs hozzárendelve',
  'dashboard.trends': 'Mai trendek',
  'dashboard.today': 'Ma',
  'dashboard.yesterday': 'Tegnap',
  'notifications.title': 'Értesítések',
  'notifications.description': 'Teljes értesítési előzménye.',
  'notifications.markAllRead': 'Összes megjelölése olvasottként',
  'notifications.filter': 'Szűrő',
  'notifications.allTypes': 'Minden típus',
  'notifications.none': 'Még nincsenek értesítések',
  'notifications.assigned': 'Hozzárendelve',
  'notifications.reply': 'Válasz',
  'notifications.note': 'Megjegyzés',
  'notifications.slaWarning': 'SLA-figyelmeztetés',
  'notifications.slaBreach': 'SLA-sértés',
  'notifications.slaEscalation': 'SLA-eszkaláció',
  'notifications.mention': 'Megemlítés',
  'preferences.title': 'Értesítési beállítások',
  'preferences.description': 'Az alkalmazáson belüli értesítések mindig aktívak. Válassza ki, melyek küldjenek e-mailt is.',
  'preferences.emailDigest': 'E-mail-összefoglaló',
  'preferences.dailySummary': 'Egy napi összefoglaló e-mail minden esemény külön üzenete helyett.',
  'preferences.digestOff': 'Ki — e-mail minden eseményről',
  'preferences.digestDaily': 'Napi összefoglaló',
  'preferences.emailNotifications': 'E-mail-értesítések',
  'activities.button': 'Legutóbbi tevékenységek',
  'activities.title': 'Legutóbbi tevékenységek',
  'activities.loadError': 'A legutóbbi tevékenységeket nem sikerült betölteni.',
  'activities.systemActor': 'Rendszer',
  'activities.noneTitle': 'Még nincs legutóbbi tevékenység',
  'activities.noneDescription': 'Az Öntől és csoportjától érkező jegyfrissítések itt jelennek meg, amint megtörténnek.',
  'tickets.title': 'Jegyek',
  'tickets.description': 'Minden jegy, amelyhez hozzáférése van, az Önnek megfelelő szűréssel és rendezéssel.',
  'tickets.dueDateTabs': 'Jegy határideje',
  'tickets.tabAll': 'Összes jegy',
  'tickets.tabDueToday': 'Mai határidejű',
  'tickets.tabOverdue': 'Lejárt',
  'tickets.tabDueTomorrow': 'Holnapi határidejű',
  'tickets.searchPlaceholder': 'Jegyek keresése…',
  'tickets.searchAria': 'Jegyek keresése',
  'tickets.filters': 'Szűrők',
  'tickets.filtersWithCount': 'Szűrők ({count})',
  'tickets.sortAria': 'Jegyek rendezése',
  'tickets.sortTrigger': 'Rendezés: {label}',
  'tickets.sortDateCreated': 'Létrehozás dátuma',
  'tickets.sortDateUpdated': 'Frissítés dátuma',
  'tickets.sortPriority': 'Prioritás',
  'tickets.sortStatus': 'Állapot',
  'tickets.sortDueDate': 'Határidő',
  'tickets.sortAscending': 'Növekvő sorrend',
  'tickets.sortDescending': 'Csökkenő sorrend',
  'tickets.ascending': 'Növekvő',
  'tickets.descending': 'Csökkenő',
  'tickets.layoutAria': 'Sorelrendezés',
  'tickets.layoutTrigger': 'Elrendezés: {label}',
  'tickets.layoutCard': 'Kártya',
  'tickets.layoutInbox': 'Beérkezett üzenetek',
  'tickets.layoutTable': 'Táblázat',
  'tickets.export': 'Exportálás',
  'tickets.exportSelected': 'Kijelöltek exportálása',
  'tickets.selectedCount': '{count} kijelölve',
  'tickets.assignAgent': 'Ügynök hozzárendelése',
  'tickets.closeAll': 'Összes lezárása',
  'tickets.clearSelection': 'Kijelölés törlése',
  'tickets.selectAgentPlaceholder': 'Válasszon ügynököt...',
  'tickets.assignTo': 'Hozzárendelés',
  'tickets.assign': 'Hozzárendelés',
  'tickets.loadFailed': 'A jegyeket nem sikerült betölteni. Kérjük, próbálja újra.',
  'tickets.bulkCloseFailed': 'A kijelölt jegyeket nem sikerült lezárni. Kérjük, próbálja újra.',
  'tickets.bulkAssignFailed': 'A kijelölt jegyeket nem sikerült hozzárendelni. Kérjük, próbálja újra.',
  'tickets.noFilterMatchTitle': 'Nincs a szűrőknek megfelelő jegy',
  'tickets.noFilterMatchDescription': 'Próbáljon meg eltávolítani egy szűrőt, kibővíteni az időtartományt, vagy más kifejezésre keresni.',
  'tickets.clearFilters': 'Szűrők törlése',
  'tickets.queueClearTitle': 'Ez a sor üres',
  'tickets.queueClearDescription': 'Az új jegyek itt jelennek meg, amikor egy ügyfél e-mailt küld, a portált használja, vagy egy ügynök létrehoz egyet.',
  'tickets.newTicket': 'Új jegy',
  'tickets.selectAllAria': 'Összes jegy kijelölése',
  'tickets.selectTicketAria': '{number}. jegy kijelölése',
  'tickets.columnContact': 'Kapcsolat',
  'tickets.columnSubject': 'Tárgy',
  'tickets.columnState': 'Állapot',
  'tickets.columnGroup': 'Csoport',
  'tickets.columnAgent': 'Ügynök',
  'tickets.columnPriority': 'Prioritás',
  'tickets.noGroup': 'Nincs csoport',
  'tickets.unassigned': 'Nincs hozzárendelve',
  'tickets.createdRelative': 'Létrehozva {when}',
  'tickets.unassignedOnly': 'Csak nem hozzárendeltek',
  'tickets.unknownRequester': 'Ismeretlen kérelmező',
  'tickets.overdueBy': 'Lejárt {duration}',
  'tickets.dueIn': 'Határidő {duration}',
  'tickets.filtersDrawerTitle': 'Szűrők',
  'tickets.filtersSearchPlaceholder': 'Mezők keresése',
  'tickets.filtersSearchAria': 'Szűrőmezők keresése',
  'tickets.filtersClearAll': 'Összes törlése',
  'tickets.filtersApply': 'Alkalmaz',
  'tickets.filterAgents': 'Ügynökök',
  'tickets.filterAnyAgent': 'Bármely ügynök',
  'tickets.filterGroups': 'Csoportok',
  'tickets.filterAnyGroup': 'Bármely csoport',
  'tickets.filterStatus': 'Állapot',
  'tickets.filterAnyStatus': 'Bármely állapot',
  'tickets.filterPriority': 'Prioritás',
  'tickets.filterAnyPriority': 'Bármely prioritás',
  'tickets.filterSource': 'Forrás',
  'tickets.filterAnySource': 'Bármely forrás',
  'tickets.filterTicketType': 'Jegy típusa',
  'tickets.filterAnyType': 'Bármely típus',
  'tickets.filterTags': 'Címkék',
  'tickets.filterAnyTag': 'Bármely címke',
  'tickets.filterCompanies': 'Vállalatok',
  'tickets.filterAnyCompany': 'Bármely vállalat',
  'tickets.filterCreated': 'Létrehozva',
  'tickets.filterResolvedAt': 'Megoldva',
  'tickets.filterClosedAt': 'Lezárva',
  'tickets.filterDateFrom': '{label} - tól',
  'tickets.filterDateTo': '{label} - ig',
  'tickets.filterDateTo2': 'ig',
  'tickets.filterAny': 'Bármely',
  'tickets.chipFieldStatus': 'Állapot',
  'tickets.chipFieldPriority': 'Prioritás',
  'tickets.chipFieldGroup': 'Csoport',
  'tickets.chipFieldAssignee': 'Felelős',
  'tickets.chipValueGroup': 'Csoport',
  'tickets.chipValueUnassigned': 'Nincs hozzárendelve',
  'common.clearSearch': 'Keresés törlése',
  'common.name': 'Név',
  'common.role': 'Szerepkör',
  'common.groups': 'Csoportok',
  'common.tickets': 'Jegyek',
  'common.lastSeen': 'Utoljára látott',
  'common.actions': 'Műveletek',
  'common.minutesAgo': '{count} perce',
  'common.hoursAgo': '{count} órája',
  'common.daysAgo': '{count} napja',
  'common.noPagePermission': 'Nincs jogosultsága ehhez az oldalhoz.',
  'common.roleNoPermission': 'Az Ön szerepköre nem jogosult ehhez az oldalhoz.',
  'common.requestFailed': 'A kérés sikertelen. Próbálja újra.',
  'common.unexpectedError': 'Váratlan hiba történt',
  'shell.skipToMain': 'Ugrás a fő tartalomhoz',
  'shell.homeLabel': 'Suzuki Support Desk kezdőlap',
  'shell.userMenu': 'Felhasználói menü',
  'shell.unread': '{count} olvasatlan',
  'shell.notificationDescription': 'Az új hozzárendelések, válaszok és SLA-riasztások itt jelennek meg.',
  'auth.enterAuthenticatorCode': 'Adja meg a 6 számjegyű kódot a hitelesítő alkalmazásból',
  'auth.verifying': 'Ellenőrzés…',
  'auth.setupAuthenticator': 'Hitelesítő beállítása',
  'auth.scanAuthenticator': 'Szkennelje be ezt a kódot hitelesítő alkalmazással (Google Authenticator, Authy stb.)',
  'auth.authenticatorSetupQr': 'Hitelesítő beállítási QR-kódja',
  'auth.verificationCodeFromAuthenticator': 'Ellenőrző kód a hitelesítőből',
  'auth.verifyAndComplete': 'Ellenőrzés és beállítás befejezése',
  'auth.loadingSetup': 'Beállítás betöltése…',
  'auth.setNewPassword': 'Új jelszó beállítása',
  'auth.temporaryPasswordExpired': 'Az ideiglenes jelszava lejárt. Kérjük, állítson be új jelszót.',
  'auth.newPassword': 'Új jelszó',
  'auth.confirmPassword': 'Jelszó megerősítése',
  'auth.settingPassword': 'Jelszó beállítása…',
  'auth.setPassword': 'Jelszó beállítása',
  'auth.passwordRequirements': 'Legalább 8 karakter, nagy- és kisbetű, szám és szimbólum szükséges',
  'auth.tooManyAttempts': 'Túl sok bejelentkezési kísérlet. Kérjük, próbálja újra később.',
  'auth.invalidCredentials': 'Érvénytelen e-mail vagy jelszó',
  'auth.passwordsDoNotMatch': 'A jelszavak nem egyeznek',
  'auth.passwordMinimum': 'A jelszónak legalább {count} karakter hosszúnak kell lennie',
  'auth.resetTitle': 'Állítsa vissza a jelszavát',
  'auth.resetSubtitle': 'Adja meg e-mail címét, és küldünk egy visszaállítási linket',
  'auth.checkEmail': 'Ellenőrizze e-mailjét a visszaállítási linkért',
  'auth.checkCode': 'Ellenőrizze e-mailjét az ellenőrző kódért, majd folytassa alább.',
  'auth.continueToReset': 'Folytatás a jelszó visszaállításához',
  'auth.sendResetLink': 'Visszaállítási link küldése',
  'auth.sending': 'Küldés…',
  'auth.resetSuccess': 'A jelszava sikeresen vissza lett állítva.',
  'auth.goToLogin': 'Ugrás a bejelentkezéshez',
  'auth.missingResetToken': 'Hiányzó visszaállítási token. Kérjük, használja az e-mailben lévő linket.',
  'auth.enterCodeFromEmail': 'Adja meg az e-mailre küldött ellenőrző kódot',
  'auth.codeFromEmail': 'Kód megadása az e-mailből',
  'auth.emailRequired': 'Az e-mail megadása kötelező',
  'auth.codeRequired': 'Az ellenőrző kód megadása kötelező',
  'auth.missingToken': 'Hiányzó visszaállítási token',
  'auth.failedReset': 'A jelszó visszaállítása sikertelen.',
  'auth.resetting': 'Visszaállítás…',
  'auth.resetPassword': 'Jelszó visszaállítása',
  'auth.looksGood': 'Rendben néz ki',
  'auth.needCharacters': 'Legalább {count} karakter szükséges',
  'auth.passwordFormat': 'Legalább {count} karakter, nagy- és kisbetű, szám és szimbólum szükséges',
  'agents.description': 'Azok, akik jegyeken dolgoznak. Rendeljen szerepkört a lehetőségek szabályozásához, és csoportokat a láthatóság szabályozásához.',
  'agents.searchAria': 'Ügynökök keresése',
  'agents.countOne': '{count} ügynök',
  'agents.countMany': '{count} ügynök',
  'agents.ticketOne': '{count} jegy',
  'agents.ticketMany': '{count} jegy',
  'agents.noGroups': 'Nincs csoport',
  'agents.lifecycle': 'Ügynök életciklusa',
  'agents.tryDifferent': 'Próbáljon meg más nevet vagy e-mail címet.',
  'agents.useNewAgent': 'Használja az Új ügynök funkciót valaki hozzáadásához, vagy váltson fület más ügynökök megtekintéséhez.',
  'agents.agent': 'Ügynök',
  'agents.noRole': 'Nincs szerepkör',
  'agents.openTicketsTitle': 'Ennek az ügynöknek jelenleg hozzárendelt nyitott jegyek',
  'agents.moreActions': 'További műveletek {name} számára',
  'agents.confirmDeleteTitle': '{name} törlése?',
  'agents.confirmDeleteDescription': 'Ez nem vonható vissza. A jegyekhez kapcsolt ügynökök nem törölhetők; inaktiválja őket helyette.',
  'agents.confirmDeleteLabel': 'Ügynök törlése',
  'agents.agentsVsCollaborators': 'Ügynökök és közreműködők',
  'agents.agentsVsCollaboratorsBody': 'A támogatási ügynökök napi szinten dolgoznak jegyeken. A közreműködők közreműködői szerepkörrel bírnak, és jellemzően szakterületi szakértők, akiket egyedi jegyekhez hívnak be teljes ügynöki hozzáférés nélkül.',
  'agents.deactivateVsDelete': 'Inaktiválás és törlés',
  'agents.deactivateVsDeleteBody': 'Az inaktiválás megőrzi az előzményeket és a jegytulajdonlást, de blokkolja a bejelentkezést. A törlés végleges, és csak akkor működik, ha az ügynökhöz nincs kapcsolt jegy.',
  'agents.newTitle': 'Új ügynök',
  'agents.editTitle': 'Ügynök szerkesztése',
  'agents.temporaryPassword': 'Ideiglenes jelszó',
  'agents.passwordHelp': 'Legalább 12 karakter. Az ügynök bejelentkezés után megváltoztathatja.',
  'agents.timezoneHelp': 'Minden dátum és idő, amelyet ez az ügynök lát, ebben az időzónában jelenik meg.',
  'agents.languageHelp': 'Lefordítja az ügynök felhasználói felületét. A jegyválaszok és az ügyfél-tartalom nem kerül lefordításra.',
  'agents.signaturePlaceholder': 'Hozzáfűzve a kimenő válaszokhoz',
  'agents.roleHelp': 'Meghatározza, hogy ez az ügynök mit tehet.',
  'agents.manageRoles': 'Szerepkörök kezelése',
  'agents.activeHelp': 'Aktív — a jelölés törlése blokkolja a bejelentkezést az ügynök törlése nélkül',
  'agents.groupHelp': 'Adja hozzá ezt az ügynököt egy csoporthoz a Csoportok képernyőn, hogy szabályozza, mely jegyeket látja.',
  'agents.about': 'Erről az ügynökről',
  'agents.aboutBody': 'A név, e-mail, telefon, időzóna, nyelv és aláírás azonosítja az ügynököt, és személyre szabja munkaterületét. A szerepkör határozza meg, mit tehet; a csoporttagság határozza meg, mely jegyeket látja.',
  'dashboard.trendsDescription': 'Jegyek létrehozása UTC óránként, tegnappal összehasonlítva.',
  'dashboard.chartAria': 'Jegymennyiség UTC óránként, mai nap a tegnapihoz képest',
  'dashboard.dataUnavailable': 'Az irányítópult adatai nem érhetők el.',
  'dashboard.loadError': 'Az irányítópult adatai nem tölthetők be. Próbálja újra.',
  'notifications.noType': 'Nincs ilyen típusú értesítés',
  'notifications.allTypesHint': 'Válassza a fenti „Minden típus” opciót a történet többi részének megtekintéséhez.',
  'notifications.emptyDescription': 'A hozzárendelések, válaszok és SLA-riasztások itt jelennek meg. Az értesítési beállításokban módosíthatja, melyek küldenek e-mailt is.',
  'preferences.digestWarning': 'A napi összefoglalón van, így ezek a beállítások figyelmen kívül maradnak, amíg ki nem kapcsolja.',
  'preferences.assignedEvent': 'Egy jegyet hozzárendeltek Önhöz',
  'preferences.replyEvent': 'Egy jegy, amelyen Ön van, választ kap',
  'preferences.noteEvent': 'Privát megjegyzés kerül hozzáadásra',
  'preferences.slaWarningEvent': 'Az SLA közeledik a határidejéhez',
  'preferences.slaBreachEvent': 'Az SLA megsértve',
  'preferences.slaEscalationEvent': 'Az SLA eszkalálódik a határidő után',
  'preferences.mentionEvent': 'Megemlítették egy jegyen',

  'ticketDetail.back': 'Vissza',
  'ticketDetail.follow': 'Követés',
  'ticketDetail.following': 'Követve',
  'ticketDetail.hideActivities': 'Tevékenységek elrejtése',
  'ticketDetail.activitiesButton': 'Tevékenységek',
  'ticketDetail.attachmentsCount': 'Mellékletek ({count})',
  'ticketDetail.threadAria': 'Jegy szál',
  'ticketDetail.conversationsTabLabel': 'Beszélgetések',
  'ticketDetail.activitiesTabLabel': 'Tevékenységek',
  'ticketDetail.noRepliesYet': 'Még nincs válasz',
  'ticketDetail.noRepliesDescription': 'Használja az alábbi szerkesztőt, hogy válaszoljon a kérelmezőnek, vagy adjon hozzá belső megjegyzést.',
  'ticketDetail.privateNote': 'Privát megjegyzés',
  'ticketDetail.forward': 'Továbbítva',
  'ticketDetail.uploadingAria': 'Feltöltés',
  'ticketDetail.uploadingProgress': '{uploading}/{total} fájl feltöltése…',
  'ticketDetail.uploadsFailed': '{count} feltöltés sikertelen',
  'ticketDetail.retry': 'Újra próbálja',
  'ticketDetail.dismiss': 'Elvetés',
  'ticketDetail.noActivityYet': 'Még nincs tevékenység',
  'ticketDetail.noActivityDescription': 'Az állapot-, ügynök- és SLA-változások itt jelennek meg a jegy folyamata során.',
  'ticketDetail.requester': 'Kérelmező',
  'ticketDetail.properties': 'Tulajdonságok',
  'ticketDetail.updating': 'Frissítés…',
  'ticketDetail.update': 'Frissítés',
  'ticketDetail.tags': 'Címkék',
  'ticketDetail.relationships': 'Kapcsolatok',
  'ticketDetail.parentTicket': 'Szülő jegy',
  'ticketDetail.unlink': 'Kapcsolat megszüntetése',
  'ticketDetail.noParentTicket': 'Nincs szülő jegy',
  'ticketDetail.childTicketsCount': 'Alárendelt jegyek ({count})',
  'ticketDetail.noChildTickets': 'Nincs alárendelt jegy',
  'ticketDetail.findTicket': 'Jegy keresése',
  'ticketDetail.ticketSearchPlaceholder': 'Jegyszám vagy tárgy',
  'ticketDetail.searchButton': 'Keresés',
  'ticketDetail.setParent': 'Beállítás szülőnek',
  'ticketDetail.mergeIntoAction': 'Összevonás ezzel',
  'ticketDetail.splitIntoChild': 'Felosztás alárendelt jegyre',
  'ticketDetail.newTicketSubjectPlaceholder': 'Új jegy tárgya',
  'ticketDetail.splitButton': 'Felosztás',
  'ticketDetail.copyAttachments': 'Mellékletek másolása',
  'ticketDetail.copyConversationHistory': 'Beszélgetési előzmények másolása',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Szüneteltetve',
  'ticketDetail.editButton': 'Szerkesztés',
  'ticketDetail.setResolutionDueDate': 'Megoldási határidő beállítása',
  'ticketDetail.pickDateTime': 'Dátum és idő kiválasztása',
  'ticketDetail.resolutionDueLabel': 'Megoldási határidő',
  'ticketDetail.saveSla': 'SLA mentése',
  'ticketDetail.savingSla': 'Mentés…',
  'ticketDetail.noSlaPolicy': 'Erre a jegyre nincs érvényben SLA-szabályzat.',
  'ticketDetail.firstResponse': 'Első válasz',
  'ticketDetail.resolution': 'Megoldás',
  'ticketDetail.done': 'Kész',
  'ticketDetail.pausedSince': 'Szüneteltetve {date} óta',
  'ticketDetail.escalation': 'Eszkaláció',
  'ticketDetail.escalatedLevel2': 'Eszkalálva (2. szint)',
  'ticketDetail.escalated': 'Eszkalálva',
  'ticketDetail.dueDateOverridden': 'A határidőt egy admin manuálisan felülírta.',
  'ticketDetail.dates': 'Dátumok',
  'ticketDetail.created': 'Létrehozva',
  'ticketDetail.updated': 'Frissítve',
  'ticketDetail.resolved': 'Megoldva',
  'ticketDetail.closed': 'Lezárva',
  'ticketDetail.loadErrorTitle': 'Nem sikerült betölteni ezt a jegyet',
  'ticketDetail.notFound': 'A jegy nem található',
  'ticketDetail.confirmMergeTitle': 'Összevonja a {source}. jegyet a {target}. jeggyel?',
  'ticketDetail.confirmMergeDescription': 'Az aktuális jegy lezárásra kerül. Ez nem vonható vissza.',
  'ticketDetail.confirmMergeLabel': 'Jegy összevonása',
  'ticketDetail.updateSuccess': 'Jegy frissítve',
  'ticketDetail.updateError': 'Nem sikerült frissíteni a jegyet',
  'ticketDetail.pickDateTitle': 'Válasszon dátumot',
  'ticketDetail.pickDateDescription': 'Válasszon megoldási határidőt.',
  'ticketDetail.slaUpdateSuccess': 'SLA frissítve',
  'ticketDetail.slaUpdateError': 'Nem sikerült frissíteni az SLA-t',
  'ticketDetail.searchError': 'Nem sikerült keresni a jegyeket',
  'ticketDetail.parentUpdateError': 'Nem sikerült frissíteni a szülő jegyet',
  'ticketDetail.mergeSuccess': 'Összevonva a {number}. jeggyel',
  'ticketDetail.mergeError': 'Nem sikerült összevonni a jegyet',
  'ticketDetail.splitSuccess': 'Jegy felosztás létrehozva',
  'ticketDetail.splitError': 'Nem sikerült felosztani a jegyet',
  'ticketDetail.downloadError': 'Nem sikerült letölteni a mellékletet',
  'ticketDetail.followSuccess': 'Most követi a jegyet',
  'ticketDetail.unfollowSuccess': 'Leállította a jegy követését',
  'ticketDetail.watcherError': 'Nem sikerült frissíteni a követési állapotot',
  'ticketDetail.fieldsLoadError': 'Nem sikerült betölteni a jegymezőket',
  'ticketDetail.overdueBy': '{label} lejárt',
  'ticketDetail.dueLeft': '{label} van hátra',
  'ticketDetail.presetToday': 'Ma',
  'ticketDetail.presetTomorrow': 'Holnap',
  'ticketDetail.presetThisWeek': 'Ezen a héten',
  'ticketDetail.presetNextWeek': 'Jövő héten',
  'ticketDetail.presetThisMonth': 'Ebben a hónapban',
  'ticketDetail.eventTicketCreated': 'Jegy létrehozva',
  'ticketDetail.eventStatusUpdated': 'Állapot frissítve',
  'ticketDetail.eventAgentUpdated': 'Ügynök frissítve',
  'ticketDetail.eventSlaUpdated': 'SLA frissítve',
  'ticketDetail.eventTicketMerged': 'Jegy összevonva',
  'ticketDetail.eventMergeReceived': 'Összevonás fogadva',
  'ticketDetail.eventTicketSplit': 'Jegy felosztva',
  'ticketDetail.eventUpdated': 'Frissítve',
  'ticketDetail.eventSplitContentCopied': 'Felosztott tartalom másolva',
  'ticketDetail.eventReplySent': 'Válasz elküldve',
  'ticketDetail.eventNoteAdded': 'Megjegyzés hozzáadva',
  'ticketDetail.eventCustomerReplied': 'Az ügyfél válaszolt',
  'ticketDetail.eventTicketDeleted': 'Jegy törölve',
  'preferences.createdEvent': 'Jegy létrehozva',
  'preferences.pendingInputEvent': 'Egy jegy az Ön válaszára vár',
  'preferences.resolvedEvent': 'Egy jegy megoldva',
  'agents.assignGroups': 'Csoportok hozzárendelése',
  'agents.assignGroupsHelp': 'A csoporttagság határozza meg, mely jegyeket láthatja ez az ügynök.',
  'agents.selectGroups': 'Csoportok kiválasztása',
  'agents.ticketVisibility': 'Jegyláthatóság',
  'agents.ticketVisibilityHelp': 'Válasszon szűkebb ügynökszintű korlátot, vagy örökölje a szerepkör alapértelmezését. A szerepkör jogosultságai továbbra is meghatározzák, mit tehet az ügynök.',
  'agents.scopeRoleDefault': 'Szerepkör alapértelmezésének használata',
  'agents.scopeRoleDefaultHelp': 'A szerepkörhöz beállított alapértelmezett láthatóság öröklése.',
  'agents.scopeAll': 'Minden jegy',
  'agents.scopeAllHelp': 'A fiók minden nem törölt jegyének megtekintése.',
  'agents.scopeGroup': 'Csoport jegyei',
  'agents.scopeGroupHelp': 'Az ügynök csoportjaihoz rendelt jegyek megtekintése.',
  'agents.scopeAssigned': 'Hozzárendelt jegyek',
  'agents.scopeAssignedHelp': 'Az ügynökhöz közvetlenül rendelt jegyek megtekintése.',
  'agents.scopeCollaboratorHelp': 'A közreműködők továbbra is az L1-csoportjaik jegyeire korlátozódnak.',
  'nav.jira': 'Jira-integráció',
  'notifications.groupAssigned': 'Csoporthozzárendelés',
  'notifications.groupMemberAdded': 'Hozzáadva a csoporthoz',
  'preferences.groupAssignedEvent': 'Egy jegy hozzá van rendelve valamelyik csoportjához',
  'preferences.groupMemberAddedEvent': 'Hozzáadták egy támogatási csoporthoz',
  'ui.select': 'Kiválasztás…',
  'ui.any': 'Bármelyik',
  'ui.typeToSearch': 'Írjon a kereséshez…',
  'ui.noResults': 'Nincs találat',
  'ui.clearSelection': 'Kijelölés törlése',
  'ui.removeItem': '{label} eltávolítása',
  'ui.pressEnterToUse': 'Nyomja meg az Entert ennek az értéknek a használatához',
  'ui.removeFilter': 'Szűrő eltávolítása: {field}: {value}',
  'ui.removeTag': '{label} címke eltávolítása',
  'ui.retry': 'Újra',
  'ui.errorTitle': 'Nem sikerült betölteni a tartalmat',
  'ui.errorMessage': 'Ellenőrizze a kapcsolatot, és próbálja újra.',
  'ui.reference': 'Hivatkozás: {id}',
  'ui.thisArea': 'ez a terület',
  'ui.noAccess': 'Nincs hozzáférése ehhez: {area}',
  'ui.noAccessHint': 'Kérje meg a rendszergazdát, hogy adja meg a szükséges jogosultságot.',
  'ui.actionFailed': 'A művelet nem hajtható végre. Próbálja újra.',
  'ui.slaPaused': 'SLA szüneteltetve',
  'ui.filteredEmptyTitle': 'Egy jegy sem felel meg ezeknek a szűrőknek',
  'ui.filteredEmptyDescription': 'Próbáljon meg eltávolítani egy szűrőt, vagy szélesíteni a dátumtartományt.',
  'ui.clearFilters': 'Szűrők törlése',
  'pagination.noResults': 'Nincs találat',
  'pagination.showing': '{first}–{last} megjelenítve, összesen: {total}',
  'pagination.resultsPerPage': 'Találatok oldalanként',
  'pagination.perPage': '{count} oldalanként',
  'pagination.previous': 'Előző',
  'pagination.next': 'Következő',
  'pagination.previousAria': 'Előző oldal',
  'pagination.nextAria': 'Következő oldal',
  'pagination.pageOf': '{page}. oldal / {total}',
  'status.open': 'Nyitott',
  'status.to_be_prioritised': 'Priorizálandó',
  'status.work_in_progress': 'Folyamatban',
  'status.assigned_to_ai_agent': 'AI-ügynöknek kiosztva',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Függőben',
  'status.awaiting_user_reply': 'Felhasználói válaszra vár',
  'status.awaiting_resolution_confirmation': 'Megoldás megerősítésére vár',
  'status.on_hold': 'Felfüggesztve',
  'status.pending_production_release': 'Éles kiadásra vár',
  'status.product_cr': 'Termék CR',
  'status.reopened': 'Újranyitva',
  'status.issue_fixed': 'Hiba javítva',
  'status.resolved': 'Megoldva',
  'status.closed': 'Lezárva',
  'status.unknown': 'Ismeretlen',
  'priority.low': 'Alacsony',
  'priority.medium': 'Közepes',
  'priority.high': 'Magas',
  'priority.urgent': 'Sürgős',
  'source.email': 'E-mail',
  'source.portal': 'Portál',
  'source.phone': 'Telefon',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Webes chat',
  'source.web_form': 'Webes űrlap',
  'source.forum': 'Fórum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Visszajelzési widget',
  'source.outbound_email': 'Kimenő e-mail',
  'source.ecommerce': 'E-kereskedelem',
  'source.bot': 'Bot',
  'source.instagram_message': 'Instagram-üzenet',
  'source.instagram_comment': 'Instagram-hozzászólás',
  'source.facebook_message': 'Facebook-üzenet',
  'source.facebook_comment': 'Facebook-hozzászólás',
  'source.mobile_chat_sdk': 'Mobile Chat SDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Mentett nézetek',
  'savedViews.saveCurrent': 'Az aktuális szűrők mentése nézetként',
  'savedViews.namePlaceholder': 'Nézet neve...',
  'savedViews.nameAria': 'Nézet neve',
  'savedViews.empty': 'Nincs mentett nézet. Alkalmazzon szűrőket, és mentse őket ide.',
  'savedViews.listAria': 'Mentett nézetek listája',
  'savedViews.rename': 'A(z) „{name}” nézet átnevezése',
  'savedViews.delete': 'A(z) „{name}” nézet törlése',
  'export.title': 'Jegyek exportálása',
  'export.loadError': 'Az exportmezők listája nem tölthető be.',
  'export.failed': 'Az exportálás sikertelen. Kérjük, próbálja újra.',
  'export.pdfFailed': 'A PDF-exportálás sikertelen. Kérjük, próbálja újra.',
  'export.fieldsSelectedOne': '{count} mező kiválasztva',
  'export.fieldsSelectedMany': '{count} mező kiválasztva',
  'export.fieldsTotalOne': 'Összesen {count} mező',
  'export.fieldsTotalMany': 'Összesen {count} mező',
  'export.selectAllFields': 'Összes mező kiválasztása',
  'export.exportingOne': '1 kijelölt jegy exportálása.',
  'export.exportingMany': '{count} kijelölt jegy exportálása.',
  'export.pdfZip': 'Letöltés PDF-ként (.zip, {count} fájl)',
  'export.pdf': 'Letöltés PDF-ként',
  'export.pdfZipHint': 'Jegyenként egy PDF-et hoz létre, és egyetlen ZIP-letöltésbe tömöríti őket.',
  'export.pdfHint': 'Egyetlen PDF-et hoz létre a jegy tulajdonságaival és a nyilvános beszélgetési szállal.',
  'export.formatLabel': 'Exportálás formátuma (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Mezőlista betöltése…',
  'export.ticketFields': 'Jegymezők',
  'export.contactFields': 'Kapcsolatmezők',
  'export.companyFields': 'Vállalati mezők',
  'export.exporting': 'Exportálás…',
  'newTicket.title': 'Jegy létrehozása',
  'newTicket.description': 'Válasszon egy mentett űrlapot, és töltse ki a mezőit.',
  'newTicket.form': 'Jegyűrlap',
  'newTicket.noForms': 'Nincs elérhető jegyűrlap. Jegy létrehozása előtt állítson be egy űrlapot.',
  'newTicket.loadFormsError': 'A jegyűrlapok nem tölthetők be',
  'newTicket.loadFormError': 'A kiválasztott jegyűrlap nem tölthető be',
  'newTicket.addCc': 'CC hozzáadása',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': '{name} eltávolítása',
  'newTicket.requesterRequired': 'A kérelmező megadása kötelező',
  'newTicket.subjectRequired': 'A tárgy megadása kötelező',
  'newTicket.createFailed': 'A jegy létrehozása sikertelen',
  'newTicket.noFormTitle': 'Nincs elérhető jegyűrlap',
  'newTicket.noFormDescription': 'Hozzon létre jegyűrlapot a Beállításokban, majd térjen vissza jegy nyitásához.',
  'newTicket.noFieldsTitle': 'Ennek az űrlapnak még nincsenek mezői',
  'newTicket.noFieldsDescription': 'Adjon mezőket az űrlaphoz a Beállításokban, majd töltse újra az oldalt.',
  'newTicket.creating': 'Létrehozás…',
  'newTicket.submit': 'Jegy létrehozása',
  'fields.required': 'A(z) {label} megadása kötelező',
  'fields.selectParentFirst': 'Először válasszon egy szülőértéket...',
  'fields.selectPlaceholder': '{label} kiválasztása...',
  'fields.enterPlaceholder': '{label} megadása...',
  'fields.optionsLoadError': 'A(z) {label} beállításai nem tölthetők be',
  'fields.label.requester': 'Kérelmező',
  'fields.label.subject': 'Tárgy',
  'fields.label.description': 'Leírás',
  'fields.label.status': 'Állapot',
  'fields.label.priority': 'Prioritás',
  'fields.label.source': 'Forrás',
  'fields.label.ticket_type': 'Típus',
  'fields.label.agent': 'Ügynök',
  'fields.label.group': 'Csoport',
  'fields.label.internal_agent': 'Belső ügynök',
  'fields.label.internal_group': 'Belső csoport',
  'fields.label.company': 'Vállalat',
  'editor.defaultPlaceholder': 'Írjon ide...',
  'editor.ariaLabel': 'Formázott szövegszerkesztő',
  'editor.toolbarAria': 'Szövegformázás',
  'editor.bold': 'Félkövér (Ctrl+B)',
  'editor.italic': 'Dőlt (Ctrl+I)',
  'editor.underline': 'Aláhúzott (Ctrl+U)',
  'editor.strikethrough': 'Áthúzott',
  'editor.heading1': '1. címsor',
  'editor.heading2': '2. címsor',
  'editor.textColor': 'Szövegszín',
  'editor.highlight': 'Kiemelés',
  'editor.bulletList': 'Felsorolás',
  'editor.numberedList': 'Számozott lista',
  'editor.blockquote': 'Idézet',
  'editor.codeBlock': 'Kódblokk',
  'editor.insertLink': 'Hivatkozás beszúrása',
  'editor.insertImage': 'Kép beszúrása',
  'editor.insertTable': 'Táblázat beszúrása',
  'editor.mention': 'Valaki megemlítése',
  'editor.undo': 'Visszavonás (Ctrl+Z)',
  'editor.redo': 'Újra (Ctrl+Shift+Z)',
  'editor.attach': 'Fájl csatolása',
  'editor.noAgents': 'Nem található ügynök',
  'editor.mentionSuggestions': 'Megemlítési javaslatok',
  'editor.dialogLinkTitle': 'Hivatkozás beszúrása',
  'editor.dialogImageTitle': 'Kép beszúrása',
  'editor.linkHint': 'Adjon meg HTTP(S), mailto, horgony vagy relatív URL-t.',
  'editor.imageHint': 'Adjon meg HTTP(S) vagy relatív kép-URL-t.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Adjon meg érvényes HTTP(S), mailto, horgony vagy relatív URL-t.',
  'editor.invalidImage': 'Adjon meg érvényes HTTP(S) vagy relatív kép-URL-t.',
  'editor.selectTextForLink': 'Hivatkozás hozzáadása előtt jelöljön ki szöveget.',
  'editor.imageInsertFailed': 'A kép nem szúrható be ide.',
  'editor.insertLinkAction': 'Hivatkozás beszúrása',
  'editor.insertImageAction': 'Kép beszúrása',
  'search.dialogAria': 'Globális keresés',
  'search.placeholder': 'Jegyek, kapcsolatok keresése...',
  'search.aria': 'Keresés',
  'search.close': 'Keresés bezárása',
  'search.noMatches': 'Nincs találat erre: „{query}”',
  'search.noMatchesHint': 'Próbáljon jegyszámot, kapcsolat e-mail-címét vagy vállalat nevét.',
  'search.hintBefore': 'Legalább 2 karaktert írjon a kereséshez. Nyomja meg a(z)',
  'search.hintAfter': 'billentyűt a bezáráshoz.',

  'td.system': 'Rendszer',
  'td.actionCreatedTicket': 'létrehozta a jegyet',
  'td.actionUpdatedFields': 'frissítette: {fields}',
  'td.fieldStatus': 'állapot',
  'td.fieldPriority': 'prioritás',
  'td.fieldSource': 'forrás',
  'td.fieldType': 'típus',
  'td.fieldGroup': 'csoport',
  'td.fieldAgent': 'ügynök',
  'td.fieldCompany': 'vállalat',
  'td.fieldContact': 'kapcsolat',
  'td.fieldSubject': 'tárgy',
  'td.fieldDescription': 'leírás',
  'td.fieldProduct': 'termék',
  'td.fieldResolutionDue': 'megoldási határidő',
  'td.fieldFirstResponseDue': 'első válasz határideje',
  'td.fieldTags': 'címkék',
  'td.fieldParentTicket': 'szülő jegy',
  'td.eventCreated': '{actor} új jegyet hozott létre',
  'td.eventCreatedLinked': '{actor} új jegyet hozott létre, és összekapcsolta egy szülő jeggyel',
  'td.eventSplit': '{actor} szétválasztotta ezt a jegyet, és létrehozta a gyermek jegyet{ref}',
  'td.eventMergeReceived': '{actor} egy másik jegyet egyesített ezzel a jeggyel{ref}',
  'td.eventMerged': '{actor} egyesítette ezt a jegyet egy másik jeggyel{ref}',
  'td.eventSplitCopied': '{actor} átmásolta: {conversations} és {attachments}',
  'td.conversationsOne': '{count} beszélgetés',
  'td.conversationsMany': '{count} beszélgetés',
  'td.attachmentsOne': '{count} melléklet',
  'td.attachmentsMany': '{count} melléklet',
  'td.eventUpdatedFields': '{actor} frissítette: {fields}',
  'td.invalidSlaState': 'A kiszolgáló érvénytelen SLA-állapotot adott vissza.',
  'td.slaRefreshError': 'Az SLA-órák frissítése nem sikerült.',
  'td.descriptionUpdated': 'Leírás frissítve',
  'td.descriptionUpdateError': 'A leírás frissítése nem sikerült',
  'td.descriptionUpdateFailed': 'A leírás frissítése sikertelen',
  'td.entryUpdated': 'Bejegyzés frissítve',
  'td.entryUpdateError': 'A bejegyzés frissítése nem sikerült',
  'td.updateFailed': 'A frissítés sikertelen',
  'td.loadOlderError': 'A régebbi beszélgetések betöltése nem sikerült',
  'td.loadFailed': 'A betöltés sikertelen',
  'td.slaUpdateFailed': 'Az SLA frissítése sikertelen',
  'td.reasonTooLong': 'Az indoklás legfeljebb 500 karakter lehet.',
  'td.invalidDateTime': 'Válasszon érvényes dátumot és időpontot.',
  'td.slaDeadlineUpdated': 'SLA-határidő frissítve',
  'td.slaConflict': 'A jegy megváltozott, miközben az SLA-adatokat szerkesztette. Töltse újra az oldalt, mielőtt újra próbálkozik.',
  'td.slaClearFailed': 'Az SLA törlése sikertelen',
  'td.slaTargetCleared': 'SLA-cél törölve',
  'td.slaClearError': 'Az SLA-cél törlése nem sikerült',
  'td.noDescription': 'Még nincs leírás hozzáadva.',
  'td.editDescriptionAria': 'Jegyleírás szerkesztése',
  'td.download': 'Letöltés',
  'td.downloadFile': '{fileName} letöltése',
  'td.loadOlder': '↓ +{count} beszélgetés',
  'td.loadOlderMany': '↓ +{count} beszélgetés',
  'td.edited': '(szerkesztve)',
  'td.privateThread': 'Privát szál',
  'td.propertiesAria': 'Jegy tulajdonságai',
  'td.expandProperties': 'Tulajdonságok kibontása',
  'td.collapseProperties': 'Tulajdonságok összecsukása',
  'td.metric': 'Mérőszám',
  'td.firstResponseOption': 'Első válasz',
  'td.resolutionOption': 'Megoldás',
  'td.overrideHint': 'Adjon meg egy kiszolgáló által hitelesített határidő-felülbírálást. Az indoklás az SLA-előzményekben megmarad.',
  'td.deadline': 'Határidő',
  'td.reasonOptional': 'Indoklás (nem kötelező)',
  'td.reasonPlaceholder': 'Jóváhagyott kivétel vagy működési háttér',
  'td.clearResolutionOverride': 'Megoldási felülbírálás törlése',
  'td.clearEscalationTarget': 'Eszkalációs cél törlése',
  'td.toolsAria': 'Jegyeszközök és kapcsolat',
  'td.ticketContext': 'Jegy környezete',
  'td.knowledgeBase': 'Tudásbázis',
  'td.shortcutsAria': 'Jegykörnyezet gyorsparancsai',
  'td.showContext': 'Jegy környezetének megjelenítése',
  'td.hideContext': 'Jegy környezetének elrejtése',
  'td.openRow': '{label} megnyitása',
  'td.editTicket': 'Jegy szerkesztése',
  'td.searchContactPlaceholder': 'Kapcsolat keresése…',
  'td.describePlaceholder': 'Írja le a problémát…',
  'td.noAttachments': 'Nincs melléklet',

  'tp.api.csrfUnavailable': 'A CSRF-védelem létrehozása nem sikerült',
  'tp.api.noMfaChallenge': 'Nincs aktív MFA-kihívás',
  'tp.api.noMfaSetup': 'Nincs aktív MFA-beállítási kihívás',
  'tp.api.noNewPasswordChallenge': 'Nincs aktív új jelszó kihívás',
  'tp.articles.isLinkedAria': '{title} megoldásként van csatolva',
  'tp.articles.linkAria': '{title} csatolása megoldásként',
  'tp.articles.linkAsSolution': 'Csatolás megoldásként',
  'tp.articles.linkedAsSolution': 'Megoldásként csatolva',
  'tp.articles.none': 'Nincs javasolt cikk ehhez a jegyhez.',
  'tp.articles.title': 'Javasolt cikkek',
  'tp.articles.views': '{count} megtekintés',
  'tp.attachment.loadingPreview': 'Előnézet betöltése…',
  'tp.attachment.previewUnavailable': 'Az előnézet nem érhető el',
  'tp.charts.noData': 'Nincs diagramadat ebben az időszakban.',
  'tp.charts.noRecords': 'Nincs rekord ebben az időszakban.',
  'tp.charts.period': 'Időszak',
  'tp.charts.showingTop': 'A(z) {total} szegmensből a legjobb {shown} látható.',
  'tp.common.cancel': 'Mégse',
  'tp.common.clear': 'Törlés',
  'tp.common.loading': 'Betöltés…',
  'tp.common.send': 'Küldés',
  'tp.common.sending': 'Küldés…',
  'tp.common.system': 'Rendszer',
  'tp.convActions.edit': 'Szerkesztés',
  'tp.convActions.thread': 'Szál indítása',
  'tp.dashboard.new': 'Új',
  'tp.dashboard.select': 'Irányítópult kiválasztása',
  'tp.forward.failed': 'A továbbítás sikertelen',
  'tp.forward.forwarded': 'Jegy továbbítva',
  'tp.forward.forwarding': 'Továbbítás…',
  'tp.forward.forwardingMany': '{count} beszélgetés továbbítása:',
  'tp.forward.forwardingOne': '1 beszélgetés továbbítása:',
  'tp.forward.message': 'Üzenet',
  'tp.forward.messagePlaceholder': 'Üzenet hozzáadása (nem kötelező)…',
  'tp.forward.noContacts': 'Nem található kapcsolat — írja be a teljes e-mail-címet',
  'tp.forward.recipientEmail': 'Címzett e-mail-címe',
  'tp.forward.recipientInvalid': 'Adjon meg érvényes címzetti e-mail-címet',
  'tp.forward.recipientRequired': 'A címzett e-mail-címe kötelező',
  'tp.forward.searchContact': 'Kapcsolat keresése vagy e-mail-cím megadása…',
  'tp.forward.title': 'Továbbítás',
  'tp.forward.to': 'Címzett',
  'tp.forward.useThisEmail': 'Nyomja meg az Entert, vagy kattintson a Továbbítás gombra az e-mail-cím használatához',
  'tp.jira.addOptional': 'Nem kötelező mezők hozzáadása',
  'tp.jira.createAndLink': 'Hibajegy létrehozása és csatolása',
  'tp.jira.createIssue': 'Hibajegy létrehozása',
  'tp.jira.createTitle': 'Jira-hibajegy létrehozása',
  'tp.jira.describePlaceholder': 'Írja le a problémát…',
  'tp.jira.description': 'Leírás',
  'tp.jira.development': 'Fejlesztés',
  'tp.jira.enterDevelopment': 'Fejlesztés megadása',
  'tp.jira.hideOptional': 'Nem kötelező mezők elrejtése',
  'tp.jira.issueId': 'Hibajegy azonosítója',
  'tp.jira.issueSummary': 'Hibajegy összefoglalója',
  'tp.jira.issueType': 'Hibajegy típusa *',
  'tp.jira.lastSync': 'Utolsó szinkronizálás: {error}',
  'tp.jira.linkIssue': 'Hibajegy csatolása',
  'tp.jira.linkTitle': 'Jira-hibajegy csatolása',
  'tp.jira.linkedIssues': 'Csatolt hibajegyek',
  'tp.jira.linkedIssuesHint': 'Használja a Jira-hibajegykulcsokat, vesszővel elválasztva.',
  'tp.jira.linkedIssuesPlaceholder': 'pl. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Jira-mezők betöltése…',
  'tp.jira.loadingIssueTypes': 'Hibajegytípusok betöltése…',
  'tp.jira.loadingProjects': 'Jira-projektek betöltése…',
  'tp.jira.loadingUsers': 'Jira-felhasználók betöltése…',
  'tp.jira.noLinks': 'Ehhez a jegyhez még nincs Jira-hibajegy csatolva.',
  'tp.jira.noneFound': 'Nem található Jira-hibajegy.',
  'tp.jira.notAvailableProject': 'Ehhez a projekthez nem érhető el',
  'tp.jira.projects': 'Projektek *',
  'tp.jira.refresh': 'Frissítés',
  'tp.jira.refreshFields': 'Jira-mezők frissítése',
  'tp.jira.reporter': 'Bejelentő',
  'tp.jira.requestFailed': 'A Jira-kérés sikertelen. Kérjük, próbálja újra.',
  'tp.jira.searchBy': 'Keresés:',
  'tp.jira.searchIssue': 'Hibajegy keresése',
  'tp.jira.searchIssuePlaceholder': 'Hibajegy keresése…',
  'tp.jira.searchUsers': 'Jira-felhasználók keresése',
  'tp.jira.searching': 'Keresés a Jirában…',
  'tp.jira.selectIssueType': 'Válasszon hibajegytípust',
  'tp.jira.selectProject': 'Válasszon projektet',
  'tp.jira.summary': 'Összefoglaló *',
  'tp.jira.syncOff': 'Szinkronizálás ki',
  'tp.jira.syncOn': 'Szinkronizálás be',
  'tp.jira.syncStatus': 'Jegyállapot szinkronizálása a Jirába',
  'tp.jira.unassigned': 'Nincs hozzárendelve',
  'tp.jira.unlink': 'Leválasztás',
  'tp.jira.unlinkConfirm': 'Hibajegy leválasztása',
  'tp.jira.unlinkDescription': 'Ez megszünteti a kapcsolatot a jeggyel, de nem törli a Jira-hibajegyet.',
  'tp.jira.unlinkTitle': '{key} leválasztása?',
  'tp.jira.untitled': 'Névtelen Jira-hibajegy',
  'tp.layout.loadingPage': 'Oldal betöltése…',
  'tp.notFound.goToDashboard': 'Ugrás az irányítópultra',
  'tp.notFound.title': 'Az oldal nem található',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Ügyfél',
  'tp.reply.addNote': 'Megjegyzés hozzáadása',
  'tp.reply.attachmentNotAdded': 'A melléklet nem lett hozzáadva',
  'tp.reply.clickToExpand': 'Kattintson a kibontáshoz',
  'tp.reply.collapsedNote': 'Belső megjegyzés hozzáadása…',
  'tp.reply.collapsedReply': 'Írjon választ vagy megjegyzést…',
  'tp.reply.conversationType': 'Beszélgetés típusa',
  'tp.reply.failedToSend': 'A küldés sikertelen',
  'tp.reply.markNoteAs': 'Megjegyzés megjelölése mint',
  'tp.reply.notVisibleToContact': 'A kapcsolat számára nem látható',
  'tp.reply.notVisibleToContacts': 'A kapcsolatok számára nem látható',
  'tp.reply.noteAdded': 'Megjegyzés hozzáadva',
  'tp.reply.notifyTo': 'Értesítendő',
  'tp.reply.placeholderPrivateNote': 'Privát megjegyzés hozzáadása...',
  'tp.reply.placeholderPublicNote': 'Nyilvános megjegyzés hozzáadása, amely látható a kérelmező számára...',
  'tp.reply.placeholderReply': 'Írja be a válaszát...',
  'tp.reply.private': 'Privát',
  'tp.reply.public': 'Nyilvános',
  'tp.reply.removeFile': '{name} eltávolítása',
  'tp.reply.replySent': 'Válasz elküldve',
  'tp.reply.searchAgentsToNotify': 'Értesítendő ügynökök keresése…',
  'tp.reply.sendReply': 'Válasz küldése',
  'tp.reply.sending': 'Küldés...',
  'tp.reply.tabNote': 'Megjegyzés',
  'tp.reply.tabReply': 'Válasz',
  'tp.reply.uploadAttachment': 'Melléklet feltöltése',
  'tp.reply.visibleToContact': 'A kapcsolat számára látható',
  'tp.reply.visibleToContacts': 'A kapcsolatok számára látható',
  'tp.sla.breached': 'Megsértve',
  'tp.sla.cleared': 'Törölve',
  'tp.sla.configErrorNoDeadline': 'SLA-konfigurációs hiba. Határidő nem kerül kikövetkeztetésre.',
  'tp.sla.configurationError': 'Konfigurációs hiba',
  'tp.sla.couldNotLoad': 'Az SLA-órák betöltése nem sikerült',
  'tp.sla.done': 'Kész',
  'tp.sla.dueIn': 'Határidő: {duration} múlva',
  'tp.sla.dueLine': 'Határidő: {date}',
  'tp.sla.dueNow': 'Most esedékes',
  'tp.sla.escalated': 'Eszkalálva',
  'tp.sla.firstResponse': 'Első válasz',
  'tp.sla.invalidDeadline': 'Érvénytelen határidő',
  'tp.sla.mayBeStale': 'Az SLA-órák elavultak lehetnek',
  'tp.sla.noActiveCycle': 'Nincs aktív SLA-ciklus.',
  'tp.sla.noDeadline': 'Nincs határidő',
  'tp.sla.noMetrics': 'Ehhez a ciklushoz nem érhetők el SLA-mérőszámok.',
  'tp.sla.noPolicy': 'Ehhez a jegyhez nincs SLA-szabályzat alkalmazva.',
  'tp.sla.notConfigured': 'Nincs konfigurálva',
  'tp.sla.notStarted': 'Nincs elindítva',
  'tp.sla.overdueBy': 'Lejárt: {duration}',
  'tp.sla.overridden': 'Felülbírálva',
  'tp.sla.overrideReason': 'Felülbírálás oka: {reason}',
  'tp.sla.paused': 'Szüneteltetve',
  'tp.sla.refreshing': 'Hiteles SLA-órák frissítése…',
  'tp.sla.resolution': 'Megoldás',
  'tp.sla.stopsSla': 'Leállítja az SLA-t',
  'tp.thread.empty': 'Még semmi sem lett elküldve. Az első üzenete indítja el ezt a privát szálat.',
  'tp.thread.messageFailed': 'Az üzenet küldése sikertelen',
  'tp.thread.privateThread': 'Privát szál',
  'tp.thread.replyPlaceholder': 'Válasz a szálban…',
  'tp.thread.someone': 'Valaki',
  'tp.thread.startPrivateThread': 'Privát szál indítása',
  'tp.thread.startedBy': '{name} elindította ezt a szálat',
  'tp.thread.unableToSend': 'Az üzenet elküldése nem sikerült',
  'tp.ui.breadcrumb': 'Navigációs útvonal',
  'tp.ui.closePanel': 'Panel bezárása',
  'tp.ui.dismiss': '{title} elvetése',

  'dir.loadError': 'Az adatok betöltése nem sikerült. Kérjük, próbálja újra.',
  'dir.contacts.description': 'Ügyfélkapcsolatok és támogatási előzményeik.',
  'dir.contacts.searchAria': 'Kapcsolatok keresése',
  'dir.contacts.count': '{count} kapcsolat',
  'dir.contacts.noMatch': 'Nincs a keresésnek megfelelő kapcsolat',
  'dir.contacts.none': 'Még nincs kapcsolat',
  'dir.contacts.noneDescription': 'A kapcsolatok itt jelennek meg, amint az ügyfelek jegyeket kezdenek beküldeni.',
  'dir.company': 'Vállalat',
  'dir.unnamedContact': 'Névtelen kapcsolat',
  'dir.contact': 'Kapcsolat',
  'dir.contactNotFound': 'A kapcsolat nem található.',
  'dir.confirmDeleteContactTitle': 'Törli: „{name}”?',
  'dir.thisContact': 'ez a kapcsolat',
  'dir.confirmDeleteContactDescription': 'A jegyekkel rendelkező kapcsolatok véglegesen nem törlődnek, hanem inaktiválásra kerülnek.',
  'dir.deleteContact': 'Kapcsolat törlése',
  'dir.editProfile': 'Profil szerkesztése',
  'dir.profile': 'Profil',
  'dir.firstName': 'Keresztnév',
  'dir.lastName': 'Vezetéknév',
  'dir.phone': 'Telefon',
  'dir.timezone': 'Időzóna',
  'dir.emailLabel': 'E-mail:',
  'dir.phoneLabel': 'Telefon:',
  'dir.companyLabel': 'Vállalat:',
  'dir.timezoneLabel': 'Időzóna:',
  'dir.recentTickets': 'Legutóbbi jegyek',
  'dir.noTicketsYet': 'Még nincs jegy',
  'dir.contactTicketsDescription': 'Az ettől a kapcsolattól származó jegyek itt jelennek meg.',
  'dir.ticket': 'Jegy',
  'dir.subject': 'Tárgy',
  'dir.status': 'Állapot',
  'dir.created': 'Létrehozva',
  'dir.companies.description': 'Az ügyfélkapcsolatokhoz és jegyekhez kapcsolódó szervezetek.',
  'dir.companies.add': 'Vállalat hozzáadása',
  'dir.companies.domain': 'Domain',
  'dir.companies.create': 'Vállalat létrehozása',
  'dir.companies.searchAria': 'Vállalatok keresése',
  'dir.companies.searchPlaceholder': 'Vállalatok vagy domainek keresése',
  'dir.companies.noMatch': 'Nincs a keresésnek megfelelő vállalat',
  'dir.companies.addFirst': 'Adja hozzá az első vállalatot',
  'dir.companies.tryDifferent': 'Próbáljon meg más vállalatnevet vagy domaint.',
  'dir.companies.useForm': 'A lista melletti űrlappal hozhat létre vállalatot.',
  'dir.companies.contacts': 'Kapcsolatok',
  'dir.companies.tickets': 'Jegyek',
  'dir.companies.notFound': 'A vállalat nem található.',
  'dir.companies.confirmDeleteTitle': 'Törli: „{name}”?',
  'dir.companies.thisCompany': 'ez a vállalat',
  'dir.companies.confirmDeleteDescription': 'A vállalatnak nem lehetnek kapcsolatai vagy jegyei, mielőtt törölhető.',
  'dir.companies.delete': 'Vállalat törlése',
  'dir.companies.noDomain': 'Nincs domain beállítva',
  'dir.companies.contactsCount': 'Kapcsolatok ({count})',
  'dir.companies.ticketsCount': 'Jegyek ({count})',
  'dir.companies.noContactsDescription': 'Adjon hozzá egy kapcsolatot, és csatolja ehhez a vállalathoz, hogy itt megjelenjen.',
  'dir.companies.noTicketsDescription': 'A vállalat kapcsolataitól származó jegyek itt jelennek meg.',
  'dir.trendsCreatedHour': 'Létrehozás dátuma - a nap órája',
  'dir.reports.loadError': 'A jelentés betöltése nem sikerült. Kérjük, próbálja újra.',
  'dir.reports.volume': 'Jegyforgalom',
  'dir.reports.sla': 'SLA-megfelelés',
  'dir.reports.agents': 'Ügynökteljesítmény',
  'dir.reports.csat': 'Ügyfél-elégedettség',
  'dir.reports.rca': 'Kiváltó ok elemzése',
  'dir.reports.descVolume': 'Nézze meg, honnan érkeznek a jegyek, és hogyan haladnak az életciklusukon.',
  'dir.reports.descSla': 'Kövesse a válaszadási és megoldási célokat a hozzáférhető támogatási működésben.',
  'dir.reports.descAgents': 'Hasonlítsa össze a munkaterhelést, az eredményeket, a válaszokat és az átlagos kezelési időket ügynökönként.',
  'dir.reports.descCsat': 'Olvassa ki az ügyfelek hangulatát anélkül, hogy a válaszok számát összetévesztené az elégedettségi aránnyal.',
  'dir.reports.descRca': 'Találja meg a jegyigény mögötti szabványosított kiváltó okokat.',
  'dir.reports.noPayload': 'Ehhez az időszakhoz nem érkezett jelentésadat.',
  'dir.reports.refresh': 'Frissítés',
  'dir.reports.report': 'Jelentés',
  'dir.reports.from': 'Kezdete',
  'dir.reports.to': 'Vége',
  'dir.reports.maxRange': 'Maximális tartomány: 90 nap · a hatókör a fiókja jogosultságait követi.',
  'dir.reports.unclassified': 'Besorolatlan',
  'dir.reports.ticketsInPeriod': 'Jegyek az időszakban',
  'dir.reports.ticketsInPeriodDetail': 'A jelentés által visszaadott hozzáférhető jegyek',
  'dir.reports.created': 'Létrehozva',
  'dir.reports.createdDetail': 'A kiválasztott dátumtengelyen',
  'dir.reports.resolved': 'Megoldva',
  'dir.reports.resolvedDetail': 'A létrehozott mennyiség {percent}%-a',
  'dir.reports.noCreated': 'Nincs létrehozott jegy',
  'dir.reports.reopened': 'Újranyitva',
  'dir.reports.reopenedDetail': 'Életciklus-események, nem egyedi jegyek',
  'dir.reports.dailyPulse': 'Napi ütem',
  'dir.reports.volumeByDate': 'Jegyforgalom dátum szerint',
  'dir.reports.volumeByDateDescription': 'A ritka háttérsorok teljes, nullákkal feltöltött dátumtengellyé bővülnek.',
  'dir.reports.createdTickets': 'Létrehozott jegyek',
  'dir.reports.createdVolumeAria': 'Létrehozott jegyek forgalma dátum szerint',
  'dir.reports.lifecycle': 'Életciklus',
  'dir.reports.lifecycleTitle': 'Létrehozva, megoldva, újranyitva',
  'dir.reports.lifecycleDescription': 'Háromvonalas nézet a jegyek életciklusán belüli mozgásról.',
  'dir.reports.lifecycleAria': 'Jegyéletciklus-események dátum szerint',
  'dir.reports.dimensions': 'Dimenziók',
  'dir.reports.whereConcentrated': 'Hol koncentrálódik a forgalom',
  'dir.reports.topEight': 'Panelenként a nyolc legnagyobb szegmens látható',
  'dir.reports.status': 'Állapot',
  'dir.reports.statusDescription': 'A jegy aktuális állapota',
  'dir.reports.priority': 'Prioritás',
  'dir.reports.priorityDescription': 'Jegyprioritások megoszlása',
  'dir.reports.group': 'Csoport',
  'dir.reports.groupDescription': 'Útválasztási csoportok',
  'dir.reports.agent': 'Ügynök',
  'dir.reports.agentDescription': 'Hozzárendelt felelősség',
  'dir.reports.product': 'Termék',
  'dir.reports.productDescription': 'Termékek megoszlása',
  'dir.reports.country': 'Ország',
  'dir.reports.countryDescription': 'Szabványosított országmezőkből',
  'dir.reports.noRecords': 'Nincs rekord ebben az időszakban.',
  'dir.reports.slaSummary': '{rate} · {met} / {total} teljesítve',
  'dir.reports.noSlaSegments': 'Még nincsenek SLA-szegmensek',
  'dir.reports.noSlaSegmentsDescription': 'A kiválasztott időszakban nincs alkalmazható SLA-rekord ehhez a dimenzióhoz.',
  'dir.reports.segment': 'Szegmens',
  'dir.reports.firstResponse': 'Első válasz',
  'dir.reports.resolution': 'Megoldás',
  'dir.reports.avgFirstResponse': 'Átl. első válasz',
  'dir.reports.avgResolution': 'Átl. megoldás',
  'dir.reports.fromTicketMetric': 'A TicketMetric alapján',
  'dir.reports.slaLens': 'SLA-nézet',
  'dir.reports.performanceBySegment': 'Teljesítmény szegmensenként',
  'dir.reports.slaRatesNote': 'Az arányok csak az alkalmazható SLA-céllal rendelkező rekordokat veszik figyelembe. Az időtartamok az átlagos eltelt időt jelentik.',
  'dir.reports.slaDimensionAria': 'SLA-bontás dimenziója',
  'dir.reports.rosterSignal': 'Névsor jelzése',
  'dir.reports.agentPerformance': 'Ügynökteljesítmény',
  'dir.reports.agentPerformanceDescription': 'Minden aktív ügynök szerepel, a tevékenység nélküliek is.',
  'dir.reports.filterAgentsAria': 'Ügynökök szűrése',
  'dir.reports.filterAgentsPlaceholder': 'Szűrés ügynök vagy e-mail alapján',
  'dir.reports.matchingAgents': '{count} egyező ügynök',
  'dir.reports.activeAgents': '{count} aktív ügynök',
  'dir.reports.sortedBy': 'rendezve: {key} {direction}',
  'dir.reports.asc': 'növekvő',
  'dir.reports.desc': 'csökkenő',
  'dir.reports.noAgentsMatch': 'Nincs a szűrőnek megfelelő ügynök',
  'dir.reports.assigned': 'Hozzárendelve',
  'dir.reports.replies': 'Válaszok',
  'dir.reports.csatScore': 'CSAT-pontszám',
  'dir.reports.csatScoreDetail': '4 vagy 5 értékelés',
  'dir.reports.averageRating': 'Átlagos értékelés',
  'dir.reports.averageRatingDetail': 'Az értékelt felmérések alapján',
  'dir.reports.ratedSurveys': 'Értékelt felmérések',
  'dir.reports.ratedSurveysDetail': 'A kiválasztott időszakban',
  'dir.reports.satisfied': 'Elégedett',
  'dir.reports.satisfiedDetail': 'Pozitív válaszok',
  'dir.reports.responseTrend': 'Válaszok trendje',
  'dir.reports.surveyVolume': 'Felmérésforgalom dátum szerint',
  'dir.reports.surveyVolumeDescription': 'A háttérrendszer a válaszok számát adja vissza dátum szerint; ez nem napi pontszám. Alább a legutóbbi 100 válasz mintája látható.',
  'dir.reports.surveyResponses': 'Felmérési válaszok',
  'dir.reports.surveyVolumeAria': 'CSAT-felmérési válaszok forgalma dátum szerint',
  'dir.reports.responsesByGroup': 'Válaszok csoportonként',
  'dir.reports.responsesByGroupDescription': 'Felmérési válaszok száma, nem csoportos elégedettségi arány',
  'dir.reports.responsesByAgent': 'Válaszok ügynökönként',
  'dir.reports.responsesByAgentDescription': 'Felmérési válaszok száma, nem ügynöki elégedettségi arány',
  'dir.reports.customerVoice': 'Az ügyfelek hangja',
  'dir.reports.latestSurveys': 'Legutóbbi felmérési válaszok',
  'dir.reports.boundedSample': 'Korlátozott minta · {count} / max. 100',
  'dir.reports.latestSurveysNote': 'A jelentési API által visszaadott legújabb válaszok. Használja ezt a táblázatot gyors áttekintéshez, nem teljes exportként.',
  'dir.reports.noSurveys': 'Nincsenek felmérési válaszok',
  'dir.reports.noSurveysDescription': 'A CSAT-válaszok itt jelennek meg, amint az ügyfelek értékelnek egy megoldott jegyet.',
  'dir.reports.rating': 'Értékelés',
  'dir.reports.comment': 'Megjegyzés',
  'dir.reports.received': 'Beérkezett',
  'dir.reports.ratingOutOf': '{rating} / 5',
  'dir.reports.noComment': 'Nincs megjegyzés',
  'dir.reports.rcaEyebrow': 'Kiváltó ok elemzése',
  'dir.reports.rcaTitle': 'Miért keletkeznek jegyek',
  'dir.reports.rcaDescription': 'A kategória és az alkategória független összesítések a szabványosított jegy-egyéni mezőkből.',
  'dir.reports.rcaDimensionAria': 'RCA-dimenzió',
  'dir.reports.category': 'Kategória',
  'dir.reports.subcategory': 'Alkategória',
  'dir.reports.rcaEmpty': 'Ebben az időszakban nem rögzítettek kiváltó ok értékeket.',
  'dir.kb.articleLoadError': 'A cikk betöltése nem sikerült.',
  'dir.kb.articleNotFound': 'A cikk nem található.',
  'dir.kb.retry': 'Újrapróbálás',
  'dir.kb.title': 'Tudásbázis',
  'dir.kb.breadcrumb': 'Tudásbázis',
  'dir.kb.description': '{articles} cikk {folders} mappában',
  'dir.kb.newArticle': 'Új cikk',
  'dir.kb.editArticle': 'Cikk szerkesztése',
  'dir.kb.sectionsAria': 'Tudásbázis szakaszai',
  'dir.kb.tabArticles': 'Cikkek',
  'dir.kb.tabStructure': 'Kategóriák és mappák',
  'dir.kb.folderFilterAria': 'Mappaszűrő',
  'dir.kb.allArticles': 'Minden cikk ({count})',
  'dir.kb.writeFirst': 'Írja meg az első cikkét',
  'dir.kb.writeFirstDescription': 'Az Új cikk gombbal adhat tartalmat ehhez a mappához.',
  'dir.kb.byAuthor': 'szerző: {name}',
  'dir.kb.views': '{count} megtekintés',
  'dir.kb.published': 'Közzétéve',
  'dir.kb.draft': 'Piszkozat',
  'dir.kb.publish': 'Közzététel',
  'dir.kb.unpublish': 'Közzététel visszavonása',
  'dir.kb.noFolders': 'Nincs mappa ebben a kategóriában',
  'dir.kb.noFoldersDescription': 'Adjon hozzá egy mappát a cikkek csoportosításának megkezdéséhez.',
  'dir.kb.articlesCount': '{count} cikk',
  'dir.kb.fieldTitle': 'Cím',
  'dir.kb.folder': 'Mappa',
  'dir.kb.selectFolder': 'Mappa kiválasztása',
  'dir.kb.content': 'Tartalom',
  'dir.kb.contentPlaceholder': 'Írja meg a cikk tartalmát...',
  'dir.kb.tags': 'Címkék (vesszővel elválasztva)',
  'dir.kb.attachments': 'Mellékletek',
  'dir.kb.download': 'Letöltés',
  'dir.kb.downloadFile': '{name} letöltése',
  'dir.kb.remove': 'Eltávolítás',
  'dir.kb.removeFile': '{name} eltávolítása',
  'dir.kb.noAttachments': 'Még nincs melléklet.',
  'dir.kb.uploadAria': 'Melléklet feltöltése',
  'dir.kb.uploading': 'Feltöltés...',
  'dir.kb.addFile': 'Fájl hozzáadása',
  'dir.kb.confirmDeleteTitle': 'Törli a cikket?',
  'dir.kb.confirmDeleteDescription': 'Ez a közzétett vagy piszkozat cikk véglegesen törlődik.',
  'dir.kb.confirmDeleteLabel': 'Cikk törlése',
  'dir.kb.confirmRemoveTitle': 'Eltávolítja a mellékletet?',
  'dir.kb.confirmRemoveDescription': 'A fájl véglegesen eltávolításra kerül ebből a cikkből.',
  'dir.kb.confirmRemoveLabel': 'Melléklet eltávolítása',
  'dir.reports.rangeInvalid': 'Válasszon érvényes kezdő és záró dátumot.',
  'dir.reports.rangeOrder': 'A záró dátumnak a kezdő dátummal egyezőnek vagy annál későbbinek kell lennie.',
  'dir.reports.rangeMax': 'A jelentések legfeljebb 90 napos dátumtartományt támogatnak.',

  'adm.active': 'Aktív',
  'adm.auto.action.add_tag': 'címke hozzáadása',
  'adm.auto.action.assign_agent': 'ügynök hozzárendelése',
  'adm.auto.action.assign_group': 'csoport hozzárendelése',
  'adm.auto.action.send_email': 'e-mail küldése',
  'adm.auto.action.send_notification': 'értesítés küldése',
  'adm.auto.action.set_priority': 'prioritás beállítása',
  'adm.auto.action.set_status': 'állapot beállítása',
  'adm.auto.actions': 'Műveletek',
  'adm.auto.addAction': '+ Művelet hozzáadása',
  'adm.auto.addCondition': '+ Feltétel hozzáadása',
  'adm.auto.addRule': 'Szabály hozzáadása',
  'adm.auto.colApplied': 'Alkalmazott műveletek',
  'adm.auto.colDate': 'Dátum',
  'adm.auto.colMatched': 'Egyezett',
  'adm.auto.colSubject': 'Tárgy',
  'adm.auto.colTicket': 'Jegy',
  'adm.auto.conditions': 'Feltételek',
  'adm.auto.confirmDesc': 'Ez a szabály azonnal leáll, és nem állítható vissza.',
  'adm.auto.confirmLabel': 'Szabály törlése',
  'adm.auto.confirmTitle': 'Törli az automatizálási szabályt?',
  'adm.auto.countMany': '{count} automatizálási szabály',
  'adm.auto.countOne': '{count} automatizálási szabály',
  'adm.auto.create': 'Létrehozás',
  'adm.auto.createFirst': 'Hozza létre az első automatizálási szabályt',
  'adm.auto.createFirstDesc': 'A Szabály hozzáadása gombbal automatikusan irányíthat, rangsorolhat vagy értesíthet.',
  'adm.auto.deleteFailed': 'A törlés sikertelen',
  'adm.auto.description': 'A szabályok pozíció szerint, egymás után futnak. Egy szabályon belül a feltételek ÉS kapcsolatban állnak.',
  'adm.auto.editRule': 'Automatizálási szabály szerkesztése',
  'adm.auto.execFailed': 'A futtatások betöltése nem sikerült',
  'adm.auto.field.assigneeId': 'felelős',
  'adm.auto.field.companyId': 'vállalat',
  'adm.auto.field.groupId': 'csoport',
  'adm.auto.field.priority': 'prioritás',
  'adm.auto.field.requesterId': 'kérelmező',
  'adm.auto.field.source': 'forrás',
  'adm.auto.field.status': 'állapot',
  'adm.auto.field.subject': 'tárgy',
  'adm.auto.field.ticketTypeId': 'jegytípus',
  'adm.auto.hits': 'Találatok',
  'adm.auto.loadFailed': 'Az automatizálási szabályok betöltése nem sikerült',
  'adm.auto.log': 'Napló',
  'adm.auto.logTitle': 'Futtatási napló — {name}',
  'adm.auto.moveDown': 'Mozgatás lefelé',
  'adm.auto.moveUp': 'Mozgatás felfelé',
  'adm.auto.newRule': 'Új automatizálási szabály',
  'adm.auto.no': 'Nem',
  'adm.auto.noRuns': 'Még nincs rögzített futtatás',
  'adm.auto.noRunsDesc': 'A futtatások itt jelennek meg, amikor ez a szabály először egyezik egy jeggyel.',
  'adm.auto.op.contains': 'tartalmazza',
  'adm.auto.op.ends_with': 'ezzel végződik',
  'adm.auto.op.greater_than': 'nagyobb, mint',
  'adm.auto.op.in': 'szerepel a következők között',
  'adm.auto.op.is': 'egyenlő',
  'adm.auto.op.is_empty': 'üres',
  'adm.auto.op.is_not': 'nem egyenlő',
  'adm.auto.op.is_not_empty': 'nem üres',
  'adm.auto.op.less_than': 'kisebb, mint',
  'adm.auto.op.not_contains': 'nem tartalmazza',
  'adm.auto.op.not_in': 'nem szerepel a következők között',
  'adm.auto.op.starts_with': 'ezzel kezdődik',
  'adm.auto.reorderFailed': 'Az átrendezés sikertelen',
  'adm.auto.saveFailed': 'A mentés sikertelen',
  'adm.auto.stopProcessing': 'A további szabályok feldolgozásának leállítása',
  'adm.auto.title': 'Automatizálási szabályok',
  'adm.auto.toggleFailed': 'A kapcsoló módosítása sikertelen',
  'adm.auto.trigger': 'Eseményindító *',
  'adm.auto.trigger.ticket_creation': 'Jegy létrehozása',
  'adm.auto.trigger.ticket_update': 'Jegy frissítése',
  'adm.auto.trigger.time_trigger': 'Időalapú',
  'adm.auto.triggerCol': 'Eseményindító',
  'adm.auto.valuePlaceholder': 'Érték',
  'adm.auto.yes': 'Igen',
  'adm.close': 'Bezárás',
  'adm.deleting': 'Törlés...',
  'adm.description': 'Leírás',
  'adm.descriptionLabel': 'Leírás',
  'adm.edit': 'Szerkesztés',
  'adm.email.addChannel': 'Csatorna hozzáadása',
  'adm.email.addTitle': 'E-mail-csatorna hozzáadása',
  'adm.email.colEmail': 'E-mail',
  'adm.email.colReplyTo': 'Válaszcím',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Ez a csatorna a továbbiakban nem lesz elérhető a támogatási levelezéshez.',
  'adm.email.confirmLabel': 'Csatorna törlése',
  'adm.email.confirmTitle': 'Törli az e-mail-csatornát?',
  'adm.email.countMany': '{count} e-mail-csatorna',
  'adm.email.countOne': '{count} e-mail-csatorna',
  'adm.email.create': 'Létrehozás',
  'adm.email.createFirst': 'Adja hozzá az első e-mail-csatornát',
  'adm.email.createFirstDesc': 'A Csatorna hozzáadása gombbal kapcsoljon egy támogatási címet, hogy a válaszok eljussanak ehhez a támogatási központhoz.',
  'adm.email.default': 'Alapértelmezett',
  'adm.email.defaultChannel': 'Alapértelmezett csatorna',
  'adm.email.deleteFailed': 'A törlés sikertelen',
  'adm.email.description': 'A bejövő/kimenő e-mail-címek, az SMTP-konfiguráció és a válaszcím-beállítások kezelése.',
  'adm.email.editTitle': 'E-mail-csatorna szerkesztése',
  'adm.email.emailAddress': 'E-mail-cím *',
  'adm.email.loadFailed': 'Az e-mail-konfigurációk betöltése nem sikerült',
  'adm.email.outbound': 'Kimenő SMTP',
  'adm.email.replyTo': 'Válaszcím',
  'adm.email.replyToPh': '(alapértelmezés: az e-mail-cím)',
  'adm.email.saveFailed': 'A mentés sikertelen',
  'adm.email.sesGlobal': 'SES (globális)',
  'adm.email.smtpHost': 'SMTP-kiszolgáló',
  'adm.email.smtpHostPh': 'pl. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'SMTP-jelszó',
  'adm.email.smtpPort': 'SMTP-port',
  'adm.email.smtpUser': 'SMTP-felhasználó',
  'adm.email.title': 'E-mail-csatornák',
  'adm.groups.aboutBody': 'A tagok határozzák meg, mely ügynökök látják alapértelmezés szerint a csoport jegyeit. A munkaidő szabályozza az ide irányított jegyek SLA-időzítését, és az eszkalációs kapcsolat a felelős mellett értesítést kap, ha egy jegy megsérti az SLA-t.',
  'adm.groups.aboutTitle': 'A csoportról',
  'adm.groups.accountDefault': 'Fiók alapértelmezése',
  'adm.groups.activeAgentMany': '{count} aktív ügynök',
  'adm.groups.activeAgentOne': '{count} aktív ügynök',
  'adm.groups.activeAgents': 'Aktív ügynökök',
  'adm.groups.addMember': 'Tag hozzáadása',
  'adm.groups.assignment': 'Hozzárendelés',
  'adm.groups.autoAssign': 'Automatikus hozzárendelés',
  'adm.groups.autoAssignNote': 'A jegyek hozzárendelése ebben a termékben mindig kézi - nincs körforgásos vagy terhelésalapú útválasztás. Ez a kapcsoló ezen nem változtat.',
  'adm.groups.businessHours': 'Munkaidő',
  'adm.groups.colGroup': 'Csoport',
  'adm.groups.confirmDesc': 'Az ezt a csoportot használó jegyeket és sablonokat előbb át kell rendelni.',
  'adm.groups.confirmLabel': 'Csoport törlése',
  'adm.groups.confirmTitle': 'Törli: „{name}”?',
  'adm.groups.createFirst': 'Hozza létre az első csoportot',
  'adm.groups.defaultHours': 'Alapértelmezett munkaidő',
  'adm.groups.editAria': '{name} szerkesztése',
  'adm.groups.editGroup': 'Csoport szerkesztése',
  'adm.groups.escalateHelp': 'Értesítési címzettként kerül hozzáadásra, ha az ebben a csoportban lévő jegy megsérti az SLA-t.',
  'adm.groups.escalateTo': 'Eszkaláció ide',
  'adm.groups.escalatesTo': 'Eszkalál ide',
  'adm.groups.escalatesToName': 'Eszkalál ide: {name}',
  'adm.groups.escalationBody': 'Ha az ebben a csoportban lévő jegy megsérti az SLA-t, az eszkalációs kapcsolat értesítési címzettként kerül hozzáadásra a felelős és a csoporttagok mellett.',
  'adm.groups.escalationTitle': 'Eszkalációs kapcsolat',
  'adm.groups.hoursHelp': 'A csoport jegyeinek SLA-számításához használatos.',
  'adm.groups.manageAgents': 'Ügynökök kezelése',
  'adm.groups.manageHours': 'Munkaidő kezelése',
  'adm.groups.manual': 'Kézi',
  'adm.groups.manualBody': 'A hozzárendelés ebben a termékben kézi - nincs körforgásos vagy terhelésalapú automatikus hozzárendelés. A csoport „Automatikus hozzárendelés” kapcsolója csak azt befolyásolja, hogy az ebbe a csoportba tartozó új jegyek alapértelmezetten hozzárendelés nélküliek maradnak-e, vagy egy meglévő útválasztási szabályra támaszkodnak; az ügynökök továbbra is maguk veszik át és adják tovább a jegyeket.',
  'adm.groups.manualTitle': 'Kézi hozzárendelés',
  'adm.groups.memberMany': '{count} tag',
  'adm.groups.memberOne': '{count} tag',
  'adm.groups.members': 'Tagok',
  'adm.groups.newGroup': 'Új csoport',
  'adm.groups.noEscalation': 'Nincs eszkalációs kapcsolat',
  'adm.groups.noMatch': 'Nincs a keresésnek megfelelő csoport',
  'adm.groups.noMembers': 'Még nincsenek tagok',
  'adm.groups.noMembersDesc': 'Válasszon ki egy aktív ügynököt fent, majd válassza a Tag hozzáadása lehetőséget.',
  'adm.groups.remove': 'Eltávolítás',
  'adm.groups.routing': 'Útválasztás',
  'adm.groups.routingMethod': 'Útválasztási módszer',
  'adm.groups.saved': 'Csoport mentve.',
  'adm.groups.searchAria': 'Csoportok keresése',
  'adm.groups.searchPlaceholder': 'Keresés név alapján',
  'adm.groups.selectActiveAgent': 'Aktív ügynök kiválasztása',
  'adm.groups.showing': '{start}-{end} megjelenítve, összesen: {total}',
  'adm.groups.subtitle': 'A csoportok szabályozzák a jegyek útválasztását és láthatóságát. Rendeljen ügynököket tagként, és válasszon munkaidő-beosztást és eszkalációs kapcsolatot minden csoporthoz.',
  'adm.groups.title': 'Csoportok',
  'adm.groups.tryDifferent': 'Próbáljon meg más csoportnevet.',
  'adm.groups.unassigned': 'Nincs hozzárendelve',
  'adm.groups.useNew': 'Az Új csoport gombbal irányíthat jegyeket ügynökök egy csoportjához.',
  'adm.groups.zero': '0 csoport',
  'adm.inactive': 'Inaktív',
  'adm.jira.accepted': 'Kapcsolat elfogadva',
  'adm.jira.accountEmail': 'Jira-fiók e-mail-címe',
  'adm.jira.accountEmailLabel': 'Fiók e-mail-címe',
  'adm.jira.activeConn': 'Aktív kapcsolat',
  'adm.jira.addConnection': 'Kapcsolat hozzáadása',
  'adm.jira.addTitle': 'Jira-kapcsolat hozzáadása',
  'adm.jira.added': 'Jira-kapcsolat hozzáadva',
  'adm.jira.apiToken': 'API-token',
  'adm.jira.clearSecret': 'Mentett webhook-titok törlése',
  'adm.jira.confirmDesc': 'Ez eltávolítja a mentett kapcsolatot és a jegykapcsolatait. A Jira-hibajegyek nem törlődnek.',
  'adm.jira.confirmLabel': 'Kapcsolat törlése',
  'adm.jira.confirmTitle': 'Törli: {name}?',
  'adm.jira.connName': 'Kapcsolat neve',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Csatlakozva mint {name}',
  'adm.jira.connectionDesk': 'Kapcsolatkezelő',
  'adm.jira.default': 'Alapértelmezett',
  'adm.jira.defaultConn': 'Alapértelmezett kapcsolat',
  'adm.jira.defaultIssueType': 'Alapértelmezett hibajegytípus',
  'adm.jira.defaultProjectKey': 'Alapértelmezett projektkulcs',
  'adm.jira.defaults': 'Alapértelmezések',
  'adm.jira.description': 'Kapcsoljon fiókhoz tartozó Jira-webhelyeket, hogy az ügynökök hibajegyeket csatolhassanak, és a jegyállapot szinkronban maradjon.',
  'adm.jira.editTitle': 'Jira-kapcsolat szerkesztése',
  'adm.jira.footer': 'Hozza létre a Jira-webhookot a fent látható végponttal, iratkozzon fel a hibajegy-frissítési eseményekre, és használja az itt beállított webhook-titkot.',
  'adm.jira.heading': 'Tartsa egy körben a támogatást és a fejlesztést',
  'adm.jira.intro': 'A hitelesítő adatok titkosítva tárolódnak a kiszolgálón, és soha nem kerülnek vissza erre a képernyőre. Állítson be webhook-titkot, ha a Jira-nak vissza kell küldenie az állapotváltozásokat a SuzukiDesknek.',
  'adm.jira.no': 'Nem',
  'adm.jira.noConns': 'Még nincsenek Jira-kapcsolatok',
  'adm.jira.noConnsDesc': 'Adjon hozzá egy kapcsolatot, hogy a Jira-műveletek elérhetők legyenek a jegy részleteiből.',
  'adm.jira.noProject': 'Nincs projekt',
  'adm.jira.pasteToken': 'Token beillesztése',
  'adm.jira.requestFailed': 'A Jira-kérés sikertelen. Kérjük, próbálja újra.',
  'adm.jira.savedToast': 'Jira-kapcsolat mentve',
  'adm.jira.secretConfigured': 'Titok beállítva: {value}',
  'adm.jira.secretHint': 'Használja ugyanazt a titkot a Jira-webhook létrehozásakor.',
  'adm.jira.secretOptional': 'Nem kötelező, 16+ karakter',
  'adm.jira.siteUrl': 'Jira-webhely URL-je',
  'adm.jira.siteUrlHint': 'Ne szerepeljenek hitelesítő adatok az URL-ben.',
  'adm.jira.syncFromJira': 'Jira-állapot vissza a jegyhez',
  'adm.jira.syncSnapshot': 'Csatolt hibajegy pillanatképe',
  'adm.jira.syncToJira': 'Jegyállapot a Jirába',
  'adm.jira.testConnection': 'Kapcsolat tesztelése',
  'adm.jira.testFailed': 'A kapcsolat tesztelése sikertelen',
  'adm.jira.title': 'Jira-integráció',
  'adm.jira.tokenHintEdit': 'Hagyja üresen a jelenlegi token megtartásához.',
  'adm.jira.tokenHintNew': 'Titkosítva tárolódik; többé nem jelenik meg.',
  'adm.jira.tokenMissing': 'Az API-token hiányzik',
  'adm.jira.tokenStored': 'API-token eltárolva',
  'adm.jira.unchanged': '(üresen hagyva változatlan)',
  'adm.jira.verified': 'Jira-kapcsolat ellenőrizve',
  'adm.jira.webhookEndpoint': 'Jira-webhook végpontja',
  'adm.jira.webhookSecret': 'Webhook-titok',
  'adm.jira.whatSyncs': 'Mi szinkronizálódik',
  'adm.jira.yes': 'Igen',
  'adm.nameRequired': 'Név *',
  'adm.nextPage': 'Következő oldal',
  'adm.notif.aud.all': 'Megosztott',
  'adm.notif.aud.customer': 'Ügyfél',
  'adm.notif.aud.internal': 'Belső',
  'adm.notif.audEmail': '{audience} e-mail',
  'adm.notif.body': 'Törzs',
  'adm.notif.description': 'Szabja testre az egyes értesítési célközönségeket anélkül, hogy az ügyfeleket a belső munkaterületre küldené.',
  'adm.notif.discardDesc': 'Az értesítési sablon mentetlen módosításai elvesznek, ha sablont vált.',
  'adm.notif.discardLabel': 'Módosítások elvetése',
  'adm.notif.discardTitle': 'Elveti a mentetlen módosításokat?',
  'adm.notif.discarded': 'A mentetlen módosítások elvetve.',
  'adm.notif.event.automation_notification': 'Automatizálási értesítés',
  'adm.notif.event.group_member_added': 'Csoporthoz adva',
  'adm.notif.event.mention': 'Megemlítés',
  'adm.notif.event.pending_input': 'Várakozás bevitelre',
  'adm.notif.event.sla_breach': 'SLA-sértés',
  'adm.notif.event.sla_escalation': 'SLA-eszkaláció',
  'adm.notif.event.sla_warning': 'SLA-figyelmeztetés',
  'adm.notif.event.ticket_assigned': 'Jegy hozzárendelve',
  'adm.notif.event.ticket_created': 'Jegy létrehozva',
  'adm.notif.event.ticket_first_response': 'Első válasz',
  'adm.notif.event.ticket_group_assigned': 'Jegy csoporthoz rendelve',
  'adm.notif.event.ticket_note': 'Privát megjegyzés',
  'adm.notif.event.ticket_public_note': 'Nyilvános megjegyzés',
  'adm.notif.event.ticket_reply': 'Jegyválasz',
  'adm.notif.event.ticket_resolved': 'Jegy megoldva',
  'adm.notif.events': 'Események',
  'adm.notif.eventsHelp': 'Válasszon eseményt és címzetti célközönséget.',
  'adm.notif.insertVar': '{variable} beszúrása',
  'adm.notif.linkNoteAgent': 'A célközönség-érzékeny {variable} hivatkozásváltozó ebben az e-mailben az ügynöki munkaterületet nyitja meg.',
  'adm.notif.linkNoteCustomer': 'A célközönség-érzékeny {variable} hivatkozásváltozó ebben az e-mailben az ügyfélportált nyitja meg.',
  'adm.notif.off': 'ki',
  'adm.notif.preview': 'Előnézet',
  'adm.notif.previewNotice': 'Az előnézet mintaadatokkal készült.',
  'adm.notif.rendering': 'Megjelenítés…',
  'adm.notif.route.all': 'A címzett-érzékeny jegyhivatkozást használja a kézbesítési célközönséghez.',
  'adm.notif.route.customer': 'Az elsődleges művelet az ügyfélportál jegyét nyitja meg.',
  'adm.notif.route.internal': 'Az elsődleges művelet az ügynöki munkaterület jegyét nyitja meg.',
  'adm.notif.sampleOnlyAgent': 'Csak mintaadatok — az elsődleges művelet az ügynöki munkaterület útvonalára mutat.',
  'adm.notif.sampleOnlyCustomer': 'Csak mintaadatok — az elsődleges művelet az ügyfélportál útvonalára mutat.',
  'adm.notif.saveChanges': 'Módosítások mentése',
  'adm.notif.saved': 'Sablon mentve.',
  'adm.notif.savedBtn': 'Mentve',
  'adm.notif.selectEvent': 'Válasszon eseményt a sablonjának szerkesztéséhez',
  'adm.notif.selectEventDesc': 'Válasszon egy értesítési eseményt a bal oldalon a tárgyának és törzsének módosításához.',
  'adm.notif.sendTest': 'Tesztlevél küldése',
  'adm.notif.sending': 'Küldés…',
  'adm.notif.subject': 'Tárgy',
  'adm.notif.testQueued': 'A tesztlevél sorba állítva ide: {email}.',
  'adm.notif.title': 'Értesítési sablonok',
  'adm.notif.urlVarTitle': 'Célközönség-érzékeny hivatkozásváltozó',
  'adm.notif.useTemplate': 'Sablon használata ennél a célközönségnél',
  'adm.notif.useTemplateHelp': 'Kikapcsolva a biztonságos tartalék értesítés kerül használatra.',
  'adm.notif.variables': 'Változók',
  'adm.notif.variablesHelp': 'Kattintson az üzenet törzséhez fűzéshez',
  'adm.pagination': 'Lapozás',
  'adm.perm.cap.admin.label': 'Hozzáférés az adminisztrációs konzolhoz',
  'adm.perm.cap.assign.label': 'Jegy hozzárendelése',
  'adm.perm.cap.close.label': 'Jegy lezárása',
  'adm.perm.cap.conversation_delete.label': 'Elküldött válasz vagy megjegyzés törlése',
  'adm.perm.cap.conversation_edit.label': 'Elküldött válasz vagy megjegyzés szerkesztése',
  'adm.perm.cap.create.label': 'Jegy létrehozása',
  'adm.perm.cap.delete.label': 'Jegy törlése',
  'adm.perm.cap.edit.label': 'Jegytulajdonságok szerkesztése',
  'adm.perm.cap.export.label': 'Jegyek exportálása',
  'adm.perm.cap.field_admin.label': 'Jegymezők',
  'adm.perm.cap.form_admin.label': 'Jegyűrlapok',
  'adm.perm.cap.forward.label': 'Jegy továbbítása',
  'adm.perm.cap.jira_link.label': 'Jira-hibajegyek csatolása és kezelése',
  'adm.perm.cap.kb.label': 'Hozzáférés a tudásbázishoz',
  'adm.perm.cap.manage_agents.label': 'Ügynökök',
  'adm.perm.cap.manage_api_keys.label': 'API-kulcsok',
  'adm.perm.cap.manage_automations.label': 'Automatizálások',
  'adm.perm.cap.manage_canned_responses.label': 'Mentett válaszok',
  'adm.perm.cap.manage_email_config.label': 'E-mail',
  'adm.perm.cap.manage_groups.label': 'Csoportok',
  'adm.perm.cap.manage_jira.label': 'Jira-integráció',
  'adm.perm.cap.manage_kb.label': 'Tudásbázis',
  'adm.perm.cap.manage_notification_templates.label': 'Értesítési sablonok',
  'adm.perm.cap.manage_roles.label': 'Szerepkörök',
  'adm.perm.cap.manage_tags.label': 'Címkék',
  'adm.perm.cap.note.label': 'Privát megjegyzések hozzáadása vagy szerkesztése',
  'adm.perm.cap.reassign.label': 'Más által már birtokolt jegy újrahozzárendelése',
  'adm.perm.cap.reopen.label': 'Megoldott vagy lezárt jegy újranyitása',
  'adm.perm.cap.reply.label': 'Nyilvános válasz az ügyfélnek',
  'adm.perm.cap.report_access.label': 'Jelentések és irányítópultok megtekintése',
  'adm.perm.cap.reports.label': 'Hozzáférés a jelentési modulhoz',
  'adm.perm.cap.resolve.label': 'Jegy megoldása',
  'adm.perm.cap.settings_admin.label': 'A Beállítások szakasz megnyitása (a Beállítások navigációs elem és indexoldala megjelenítéséhez szükséges; az alábbi oldalak mindegyikéhez való hozzáférés továbbra is külön szabályozott)',
  'adm.perm.cap.sla_admin.label': 'SLA-szabályzatok és munkaidő',
  'adm.perm.cap.sla_edit.desc': 'Független az alábbi Beállítások > SLA-szabályzatok jogosultságtól — ez csak az egyes jegyek határidejének szerkesztésére vonatkozik.',
  'adm.perm.cap.sla_edit.label': 'Jegy SLA-határidejének kézi felülbírálása',
  'adm.perm.cap.tag.label': 'Jegycímkék kezelése',
  'adm.perm.cap.thread_start.label': 'Privát szál indítása egy beszélgetési bejegyzésen',
  'adm.perm.cap.tickets.label': 'Hozzáférés a jegyek munkaterületéhez',
  'adm.perm.cap.view.label': 'Hatókörön belüli jegyek megtekintése',
  'adm.perm.cat.administration.desc': 'Hozzáférés az adminisztrációs konzolhoz és konfigurációs képernyőihez.',
  'adm.perm.cat.administration.label': 'Adminisztráció',
  'adm.perm.cat.knowledge.desc': 'Tudásbázis-tartalom olvasása és használata jegy kezelése közben.',
  'adm.perm.cat.knowledge.label': 'Tudásbázis',
  'adm.perm.cat.reporting.desc': 'Működési jelentések és irányítópultok.',
  'adm.perm.cat.reporting.label': 'Jelentések',
  'adm.perm.cat.settings-pages.desc': 'Az egyes Beállítások képernyőkhöz külön adhat hozzáférést. Semmi sem látható, amíg itt kifejezetten be nincs jelölve.',
  'adm.perm.cat.settings-pages.label': 'Beállítások oldalai',
  'adm.perm.cat.tickets.desc': 'Mit tehet egy ügynök a jegyek munkaterületén.',
  'adm.perm.cat.tickets.label': 'Jegyek',
  'adm.previousPage': 'Előző oldal',
  'adm.refresh': 'Frissítés',
  'adm.roleType.administrator': 'Adminisztrátor',
  'adm.roleType.agent': 'Ügynök',
  'adm.roleType.collaborator': 'Közreműködő',
  'adm.roleType.customer': 'Ügyfél',
  'adm.roleType.super_admin': 'Szuperadminisztrátor',
  'adm.roleType.supervisor': 'Felügyelő',
  'adm.roles.activeHelp': 'Aktív - az inaktív szerepkörök nem rendelhetők ügynökökhöz',
  'adm.roles.agentCan': 'Az ügynök jogosult',
  'adm.roles.agentType': 'Ügynöktípus',
  'adm.roles.agentsAssignedNote': 'Az ügynökökhöz ez a szerepkör az Ügynökök képernyőn rendelhető.',
  'adm.roles.agentsCount': '{count} ügynök',
  'adm.roles.agentsLabel': 'Ügynökök',
  'adm.roles.agentsManage': '{count} ügynök - Kezelés',
  'adm.roles.builtIn': '(Beépített)',
  'adm.roles.builtInNote': 'Ez egy beépített szerepkör. Átnevezhető és inaktiválható, de nem törölhető.',
  'adm.roles.builtInTitle': 'Beépített szerepkör: szerkeszthető és inaktiválható, de nem törölhető',
  'adm.roles.categoriesAria': 'Jogosultsági kategóriák',
  'adm.roles.confirmDesc': 'A szerepkörhöz rendelt ügynököknek másik szerepkörre lesz szükségük, mielőtt eltávolítható.',
  'adm.roles.confirmLabel': 'Szerepkör törlése',
  'adm.roles.createFirst': 'Hozza létre az első szerepkört',
  'adm.roles.createFirstDesc': 'Az Új szerepkör gombbal határozza meg, milyen képességeket kapjanak az ügynökök.',
  'adm.roles.editRole': 'Szerepkör szerkesztése',
  'adm.roles.granted': '{count} megadva',
  'adm.roles.heading': 'Ügynök-szerepkörök',
  'adm.roles.inactive': 'Inaktív',
  'adm.roles.newRole': 'Új szerepkör',
  'adm.roles.noAgent': 'Nincs ügynök',
  'adm.roles.notEnforced': '(még nincs érvényesítve)',
  'adm.roles.notEnforcedTitle': 'A szerepkörben tárolva, de futásidőben még sehol sem érvényesül',
  'adm.roles.permissions': 'Jogosultságok',
  'adm.roles.saved': 'Szerepkör mentve.',
  'adm.roles.scopeBody': 'A képességek a sorszintű hatókörrel (összes / csoport / hozzárendelt / saját) együtt érvényesülnek, így az ügynök csak olyan jegyeken járhat el, amelyeket már láthat.',
  'adm.roles.scopeTitle': 'A hatókör továbbra is érvényes',
  'adm.roles.scrollTo': 'Ugrás ide',
  'adm.roles.status': 'Állapot',
  'adm.roles.subtitle': 'Finomhangolt hozzáférési szintek és jogosultságok biztosítása és korlátozása az ügynökök számára.',
  'adm.roles.title': 'Szerepkörök',
  'adm.roles.typeLocked': 'Az ügynöktípus a szerepkör mentése után nem módosítható.',
  'adm.roles.understandingBody1': 'A szerepkörök határozzák meg, mit tehet egy ügynök. Hozzon létre szerepkört, jelölje be a megadandó képességeket, majd rendelje az ügynökökhöz az Ügynökök képernyőn.',
  'adm.roles.understandingBody2': 'A beépített szerepkörök átnevezhetők és inaktiválhatók, de soha nem törölhetők. Az a szerepkör sem törölhető, amelyhez még vannak ügynökök rendelve, ezért először azokat helyezze át.',
  'adm.roles.understandingTitle': 'A szerepkörök megértése',
  'adm.saveChanges': 'Módosítások mentése',
  'adm.settings.add': '{name} hozzáadása',
  'adm.settings.back': 'Vissza a beállításokhoz',
  'adm.settings.cannedDesc': 'A jegyek kezelése közben elérhető fiókszintű válaszok.',
  'adm.settings.cannedEmpty': 'Még nincsenek mentett válaszok',
  'adm.settings.cannedEmptyDesc': 'Kérjen meg egy adminisztrátort, hogy adjon hozzá megosztott válaszokat, amelyeket a csapata újra felhasználhat egy jegyen.',
  'adm.settings.cannedTitle': 'Mentett válaszok',
  'adm.settings.col.autoAssign': 'Automatikus hozzárendelés',
  'adm.settings.col.color': 'Szín',
  'adm.settings.col.content': 'Tartalom',
  'adm.settings.col.createdAt': 'Létrehozva',
  'adm.settings.col.description': 'Leírás',
  'adm.settings.col.email': 'E-mail',
  'adm.settings.col.expiresAt': 'Lejár',
  'adm.settings.col.fieldType': 'Mezőtípus',
  'adm.settings.col.firstName': 'Keresztnév',
  'adm.settings.col.folderId': 'Mappa azonosítója',
  'adm.settings.col.hitCount': 'Találatok száma',
  'adm.settings.col.holidays': 'Ünnepnapok',
  'adm.settings.col.host': 'Kiszolgáló',
  'adm.settings.col.hours': 'Órák',
  'adm.settings.col.id': 'Azonosító',
  'adm.settings.col.isActive': 'Aktív',
  'adm.settings.col.isBuiltIn': 'Beépített',
  'adm.settings.col.isDefault': 'Alapértelmezett',
  'adm.settings.col.isRequired': 'Kötelező',
  'adm.settings.col.isShared': 'Megosztott',
  'adm.settings.col.isSystem': 'Rendszer',
  'adm.settings.col.key': 'Kulcs',
  'adm.settings.col.label': 'Címke',
  'adm.settings.col.language': 'Nyelv',
  'adm.settings.col.lastName': 'Vezetéknév',
  'adm.settings.col.lastUsedAt': 'Utoljára használva',
  'adm.settings.col.name': 'Név',
  'adm.settings.col.options': 'Beállítások',
  'adm.settings.col.phone': 'Telefon',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Pozíció',
  'adm.settings.col.prefix': 'Előtag',
  'adm.settings.col.priority': 'Prioritás',
  'adm.settings.col.required': 'Kötelező',
  'adm.settings.col.role': 'Szerepkör',
  'adm.settings.col.roleId': 'Szerepkör azonosítója',
  'adm.settings.col.scopes': 'Hatókörök',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Állapot',
  'adm.settings.col.stopProcessing': 'Feldolgozás leállítása',
  'adm.settings.col.timezone': 'Időzóna',
  'adm.settings.col.title': 'Cím',
  'adm.settings.col.trigger': 'Eseményindító',
  'adm.settings.col.type': 'Típus',
  'adm.settings.col.updatedAt': 'Frissítve',
  'adm.settings.col.usageCount': 'Használatok száma',
  'adm.settings.col.username': 'Felhasználónév',
  'adm.settings.confirmDesc': 'Ez nem vonható vissza.',
  'adm.settings.confirmTitle': 'Törli: {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Létrehozás',
  'adm.settings.empty': 'Még nincs {title}',
  'adm.settings.emptyAdd': 'Az első {name} hozzáadásához használja a fenti űrlapot.',
  'adm.settings.emptyOther': 'A bejegyzések itt jelennek meg, amint konfigurálták őket.',
  'adm.settings.homeDesc': 'Felhasználók, jegy-munkafolyamatok, szolgáltatási szintek és integrációk konfigurálása.',
  'adm.settings.manage': '{title} kezelése.',
  'adm.settings.noPages': 'Nincsenek elérhető beállítási oldalak',
  'adm.settings.noPagesDesc': 'Kérje meg a szuperadminisztrátort, hogy adjon hozzáférést a szükséges beállítási oldalakhoz.',
  'adm.settings.notFound': 'A beállítási oldal nem található',
  'adm.settings.notFoundDesc': 'A folytatáshoz válasszon egy beállítási területet.',
  'adm.settings.res.agents.field.email': 'E-mail',
  'adm.settings.res.agents.field.firstName': 'Keresztnév',
  'adm.settings.res.agents.field.lastName': 'Vezetéknév',
  'adm.settings.res.agents.field.password': 'Ideiglenes jelszó',
  'adm.settings.res.agents.field.roleId': 'Szerepkör azonosítója',
  'adm.settings.res.agents.one': 'ügynök',
  'adm.settings.res.agents.title': 'Ügynökök',
  'adm.settings.res.api-keys.field.name': 'Kulcs neve',
  'adm.settings.res.api-keys.one': 'API-kulcs',
  'adm.settings.res.api-keys.title': 'API-kulcsok',
  'adm.settings.res.automations.field.description': 'Leírás',
  'adm.settings.res.automations.field.name': 'Név',
  'adm.settings.res.automations.one': 'automatizálás',
  'adm.settings.res.automations.title': 'Automatizálások',
  'adm.settings.res.business-hours.field.name': 'Név',
  'adm.settings.res.business-hours.field.timezone': 'Időzóna',
  'adm.settings.res.business-hours.one': 'munkaidő-bejegyzés',
  'adm.settings.res.business-hours.title': 'Munkaidő',
  'adm.settings.res.canned-responses.field.content': 'Válasz tartalma',
  'adm.settings.res.canned-responses.field.title': 'Cím',
  'adm.settings.res.canned-responses.one': 'mentett válasz',
  'adm.settings.res.canned-responses.title': 'Mentett válaszok',
  'adm.settings.res.email.field.host': 'SMTP-kiszolgáló',
  'adm.settings.res.email.field.name': 'Név',
  'adm.settings.res.email.field.port': 'SMTP-port',
  'adm.settings.res.email.field.username': 'Felhasználónév',
  'adm.settings.res.email.one': 'e-mail-konfiguráció',
  'adm.settings.res.email.title': 'E-mail-konfiguráció',
  'adm.settings.res.fields.one': 'jegymező',
  'adm.settings.res.fields.title': 'Jegymezők',
  'adm.settings.res.forms.field.label': 'Megjelenített címke',
  'adm.settings.res.forms.field.name': 'Mező neve',
  'adm.settings.res.forms.field.type': 'Mező típusa',
  'adm.settings.res.forms.one': 'űrlap vagy egyéni mező',
  'adm.settings.res.forms.title': 'Űrlapok és egyéni mezők',
  'adm.settings.res.groups.field.description': 'Leírás',
  'adm.settings.res.groups.field.name': 'Név',
  'adm.settings.res.groups.one': 'csoport',
  'adm.settings.res.groups.title': 'Csoportok',
  'adm.settings.res.jira.one': 'Jira-integráció',
  'adm.settings.res.jira.title': 'Jira-integráció',
  'adm.settings.res.kb.field.content': 'Cikk tartalma',
  'adm.settings.res.kb.field.folderId': 'Mappa azonosítója',
  'adm.settings.res.kb.field.title': 'Cikk címe',
  'adm.settings.res.kb.one': 'tudásbázis-cikk',
  'adm.settings.res.kb.title': 'Tudásbázis adminisztrációja',
  'adm.settings.res.notification-templates.one': 'értesítési sablon',
  'adm.settings.res.notification-templates.title': 'Értesítési sablonok',
  'adm.settings.res.roles.field.description': 'Leírás',
  'adm.settings.res.roles.field.name': 'Név',
  'adm.settings.res.roles.field.type': 'Szerepkör típusa',
  'adm.settings.res.roles.one': 'szerepkör',
  'adm.settings.res.roles.title': 'Szerepkörök',
  'adm.settings.res.sla.field.description': 'Leírás',
  'adm.settings.res.sla.field.name': 'Név',
  'adm.settings.res.sla.one': 'SLA-szabályzat',
  'adm.settings.res.sla.title': 'SLA-szabályzatok',
  'adm.settings.res.tags.field.name': 'Név',
  'adm.settings.res.tags.one': 'címke',
  'adm.settings.res.tags.title': 'Címkék',
  'adm.settings.title': 'Beállítások',
  'adm.status': 'Állapot',

  'sla.edit': 'Szerkesztés',
  'sla.active': 'Aktív',
  'sla.inactive': 'Inaktív',
  'sla.default': 'Alapértelmezett',
  'sla.yes': 'Igen',
  'sla.no': 'Nem',
  'sla.description': 'Leírás',
  'sla.status': 'Állapot',
  'sla.notConfigured': 'Nincs konfigurálva',
  'sla.minutesValue': '{value} perc',
  'sla.invalidServerValue': 'Érvénytelen kiszolgálóérték',
  'sla.statusSemantics.title': 'Jegyállapotok szemantikája',
  'sla.statusSemantics.description': 'Minden aktív állapothoz kifejezett SLA-szerződés tartozik. A szüneteltető állapot és az SLA-t leállító állapot kölcsönösen kizárja egymást.',
  'sla.statusSemantics.conflict': 'Egy állapot nem szüneteltetheti és állíthatja le egyszerre az SLA-t.',
  'sla.statusSemantics.emptyTitle': 'Nincsenek állapotdefiníciók',
  'sla.statusSemantics.emptyDescription': 'Az állapotdefiníciók itt jelennek meg, amint konfigurálták őket ehhez a fiókhoz.',
  'sla.statusSemantics.colPauses': 'Szünetelteti az SLA-t',
  'sla.statusSemantics.colStops': 'Leállítja az SLA-t',
  'sla.statusSemantics.pausesAria': '{label} szünetelteti az SLA-t',
  'sla.statusSemantics.stopsAria': '{label} leállítja az SLA-t',
  'sla.preview.title': 'Csak olvasható jegyelőnézet',
  'sla.preview.description': 'Futtassa ugyanazt a fiókhatókörű kiértékelőt, amelyet az élő SLA-ciklusok használnak. Ez az előnézet soha nem ír szabályzatot vagy jegyet.',
  'sla.preview.priority': 'Prioritás',
  'sla.preview.group': 'Csoport',
  'sla.preview.anyGroup': 'Bármely csoport',
  'sla.preview.company': 'Vállalat',
  'sla.preview.anyCompany': 'Bármely vállalat',
  'sla.preview.source': 'Forrás',
  'sla.preview.anySource': 'Bármely forrás',
  'sla.preview.ticketType': 'Jegy típusa',
  'sla.preview.anyTicketType': 'Bármely jegytípus',
  'sla.preview.representativeStart': 'Reprezentatív kezdés',
  'sla.preview.calculating': 'Számítás…',
  'sla.preview.run': 'Előnézet futtatása',
  'sla.preview.configAttention': 'A konfiguráció figyelmet igényel',
  'sla.preview.selectedPolicy': 'Kiválasztott szabályzat',
  'sla.preview.noPolicy': 'Nincs szabályzat',
  'sla.preview.evaluationOrder': 'Kiértékelési sorrend',
  'sla.preview.firstMatching': 'Az első egyező szabályzat',
  'sla.preview.calculationMode': 'Számítási mód',
  'sla.preview.modeBusinessHours': 'Munkaidő',
  'sla.preview.modeBusinessHoursNamed': 'Munkaidő · {name}',
  'sla.preview.mode247': '0–24 órás eltelt idő',
  'sla.preview.modeNone': 'Nincs kiszámítva',
  'sla.preview.thresholds': 'Független küszöbértékek',
  'sla.preview.colMetric': 'Mérőszám',
  'sla.preview.colTarget': 'Cél',
  'sla.preview.colWarning': 'Figyelmeztetés',
  'sla.preview.colDue': 'Határidő / sértés',
  'sla.preview.colEscalation': 'Eszkaláció',
  'sla.preview.colState': 'Állapot',
  'sla.preview.metricFirstResponse': 'Első válasz',
  'sla.preview.metricResolution': 'Megoldás',
  'sla.preview.trace': 'Szabályzat-kiértékelési napló',
  'sla.preview.selected': 'Kiválasztva',
  'sla.preview.matchedAfterSelection': 'A kiválasztás után egyezett',
  'sla.preview.skipped': 'Kihagyva',
  'sla.preview.showTrace': 'Számítási napló megjelenítése',
  'sla.state.not_configured': 'nincs konfigurálva',
  'sla.state.running': 'fut',
  'sla.state.paused': 'szüneteltetve',
  'sla.state.warning': 'figyelmeztetés',
  'sla.state.breached': 'megsértve',
  'sla.state.met': 'teljesítve',
  'sla.state.escalated': 'eszkalálva',
  'sla.state.pending': 'függőben',
  'sla.state.stopped': 'leállítva',
  'sla.state.on_track': 'megfelelő ütemben',
  'sla.state.at_risk': 'veszélyben',
  'sla.list.subtitle': 'Állítson be első válasz és megoldási célokat prioritásonként. A szabályzatok fentről lefelé értékelődnek ki — az első, amelynek feltételei egyeznek a jeggyel, érvényesül.',
  'sla.list.newPolicy': 'Új szabályzat',
  'sla.list.emptyTitle': 'Hozza létre az első SLA-szabályzatot',
  'sla.list.emptyDescription': 'Az Új szabályzat gombbal állítson be első válasz és megoldási célokat prioritásonként.',
  'sla.list.moveUp': 'Mozgatás felfelé',
  'sla.list.moveDown': 'Mozgatás lefelé',
  'sla.list.frShort': 'Első válasz: {value}',
  'sla.list.resolveShort': 'Megoldás: {value}',
  'sla.list.escalateShort': 'Eszkaláció: +{value}',
  'sla.list.deactivate': 'Inaktiválás',
  'sla.list.activate': 'Aktiválás',
  'sla.list.setDefault': 'Beállítás alapértelmezettként',
  'sla.list.duplicate': 'Másolás',
  'sla.list.deleteTitle': 'Törli: „{name}”?',
  'sla.list.deleteDescription': 'Az ehhez a szabályzathoz társított jegyek a következő elérhető SLA-szabályzatot fogják használni.',
  'sla.list.deleteConfirm': 'Szabályzat törlése',
  'sla.conditions.groups': '{count} csoport',
  'sla.conditions.companies': '{count} vállalat',
  'sla.conditions.sources': 'források: {list}',
  'sla.conditions.ticketTypes': '{count} jegytípus',
  'sla.conditions.anyOf': 'bármelyik',
  'sla.conditions.allOf': 'mindegyik',
  'sla.conditions.summary': 'Feltételek ({mode}): {parts}',
  'sla.edit.newTitle': 'Új SLA-szabályzat',
  'sla.edit.editTitle': 'SLA-szabályzat szerkesztése',
  'sla.edit.saved': 'SLA-szabályzat mentve.',
  'sla.edit.name': 'Név',
  'sla.edit.appliesToPriority': 'Alkalmazandó prioritás',
  'sla.edit.evaluationOrder': 'Kiértékelési sorrend',
  'sla.edit.evaluationOrderHint': 'Ennél a fióknál az alacsonyabb pozíciók értékelődnek ki előbb.',
  'sla.edit.defaultPolicy': 'Alapértelmezett szabályzat',
  'sla.edit.useAsDefault': 'Használat alapértelmezettként, ha nincs más egyező szabályzat',
  'sla.edit.targets': 'SLA-célok',
  'sla.edit.firstResponse': 'Első válasz',
  'sla.edit.resolution': 'Megoldás',
  'sla.edit.autoAt75': 'Automatikus 75%-nál',
  'sla.edit.enabledAfter': 'Engedélyezve ennyi után: {value}',
  'sla.edit.clearEscalation': 'Eszkalációs cél kifejezett törlése',
  'sla.edit.clearEscalationHint': 'Null értéket küld; ha nincs bejelölve, a mező kimarad, és a mentett érték megmarad.',
  'sla.edit.firstResponseMinutes': 'Első válasz (perc)',
  'sla.edit.resolutionMinutes': 'Megoldás (perc)',
  'sla.edit.escalateAfter': 'Eszkaláció ennyi után (perc a megoldási határidő lejárta után)',
  'sla.edit.notSet': 'Nincs beállítva',
  'sla.edit.remindersNote': 'Az emlékeztetők automatikusan az első válasz és a megoldási időablak 75%-ánál aktiválódnak. Az eszkaláció értesíti a jegy csoportjának eszkalációs ügynökét (a csoportnál beállítva), amint a megoldási célt a beállított percszámmal elmulasztották.',
  'sla.edit.conditions': 'Feltételek',
  'sla.edit.conditionsHint': 'Hagyjon egy csoportot bejelöletlenül az összes érték egyeztetéséhez',
  'sla.edit.matchMode': 'Egyeztetési mód:',
  'sla.edit.matchAll': 'Az ÖSSZES feltétel egyezzen',
  'sla.edit.matchAny': 'BÁRMELY feltétel egyezzen',
  'sla.edit.groups': 'Csoportok',
  'sla.edit.companies': 'Vállalatok',
  'sla.edit.sources': 'Források',
  'sla.edit.ticketTypes': 'Jegytípusok',
  'sla.bh.subtitle': 'Határozza meg a heti beosztást és az ünnepnaptárat, amelyet az SLA-szabályzatok a határidők kiszámításához használnak.',
  'sla.bh.newCalendar': 'Új naptár',
  'sla.bh.emptyTitle': 'Hozza létre az első munkaidő-naptárat',
  'sla.bh.emptyDescription': 'Az Új naptár gombbal határozza meg a heti beosztást, amelyet az SLA-szabályzatok számításba vesznek.',
  'sla.bh.accountDefault': 'Fiók alapértelmezése',
  'sla.bh.closedEveryDay': 'Minden nap zárva',
  'sla.bh.openEveryDay': 'Minden nap nyitva',
  'sla.bh.openDaysOne': 'Heti 1 nap nyitva',
  'sla.bh.openDaysMany': 'Heti {count} nap nyitva',
  'sla.bh.holidayOne': '1 ünnepnap',
  'sla.bh.holidayMany': '{count} ünnepnap',
  'sla.bh.deleteTitle': 'Törli: „{name}”?',
  'sla.bh.deleteDescription': 'Az ezt a beosztást használó SLA-szabályzatok és csoportok a fiók alapértelmezésére térnek vissza.',
  'sla.bh.deleteConfirm': 'Beosztás törlése',
  'sla.bh.newTitle': 'Új munkaidő-naptár',
  'sla.bh.editTitle': 'Munkaidő szerkesztése',
  'sla.bh.saved': 'Munkaidő mentve.',
  'sla.bh.timezone': 'Időzóna',
  'sla.bh.defaultCalendar': 'Alapértelmezett naptár',
  'sla.bh.useAsDefault': 'Használat azokhoz az SLA-szabályzatokhoz és csoportokhoz, amelyek nem adnak meg saját naptárat',
  'sla.bh.weeklySchedule': 'Heti beosztás',
  'sla.bh.colDay': 'Nap',
  'sla.bh.colOpen': 'Nyitva',
  'sla.bh.colStart': 'Kezdés',
  'sla.bh.colEnd': 'Befejezés',
  'sla.bh.dayOpenAria': '{day} nyitva',
  'sla.bh.dayStartAria': '{day} kezdési ideje',
  'sla.bh.dayEndAria': '{day} befejezési ideje',
  'sla.bh.holidayCalendar': 'Ünnepnaptár',
  'sla.bh.saveFirst': 'Először mentse ezt a naptárat, majd adjon hozzá ünnepnapokat.',
  'sla.bh.holidayName': 'Ünnepnap neve',
  'sla.bh.date': 'Dátum',
  'sla.bh.addHoliday': 'Ünnepnap hozzáadása',
  'sla.bh.noHolidays': 'Még nincsenek ünnepnapok',
  'sla.bh.noHolidaysHint': 'Adjon hozzá egy dátumozott ünnepnapot fent, hogy kizárja az SLA-számításokból.',
  'sla.bh.remove': 'Eltávolítás',
  'sla.day.monday': 'Hétfő',
  'sla.day.tuesday': 'Kedd',
  'sla.day.wednesday': 'Szerda',
  'sla.day.thursday': 'Csütörtök',
  'sla.day.friday': 'Péntek',
  'sla.day.saturday': 'Szombat',
  'sla.day.sunday': 'Vasárnap',

  'set.ftype.single_line_text': 'Egysoros szöveg',
  'set.ftype.multi_line_text': 'Többsoros szöveg',
  'set.ftype.dropdown': 'Legördülő lista',
  'set.ftype.checkbox': 'Jelölőnégyzet',
  'set.ftype.radio': 'Választógomb',
  'set.ftype.multiselect': 'Többszörös választás',
  'set.ftype.lookup': 'Keresési kapcsolat',
  'set.ftype.dependent': 'Függő mező',
  'set.ftype.date': 'Dátum',
  'set.ftype.number': 'Szám',
  'set.ftype.decimal': 'Tizedes tört',
  'set.ftype.desc.lookup': 'Rekord kiválasztása egy rendszerforrásból.',
  'set.ftype.desc.single_line_text': 'Rövid szöveges érték.',
  'set.ftype.desc.multi_line_text': 'Hosszú szöveges érték.',
  'set.ftype.desc.checkbox': 'Igaz vagy hamis érték.',
  'set.ftype.desc.dropdown': 'Egy normalizált lehetőség kiválasztása.',
  'set.ftype.desc.dependent': 'A lehetőségek egy szülőmezőtől függenek.',
  'set.ftype.desc.date': 'Naptári dátum érték.',
  'set.ftype.desc.number': 'Egész szám érték.',
  'set.ftype.desc.decimal': 'Tizedes szám érték.',
  'set.src.STATIC': 'Statikus lehetőségek',
  'set.src.AGENTS': 'Ügynökök',
  'set.src.USERS': 'Felhasználók / Ügyfelek',
  'set.src.GROUPS': 'Csoportok',
  'set.src.ROLE': 'Szerepkörök',
  'set.src.COUNTRIES': 'Országok',
  'set.src.CUSTOM': 'Egyéni legördülő lista',
  'set.settings': 'Beállítások',
  'set.ticketFields': 'Jegymezők',
  'set.ticketForms': 'Jegyűrlapok',
  'set.requestFailed': 'A kérés sikertelen. Kérjük, próbálja újra.',
  'set.refresh': 'Frissítés',
  'set.saving': 'Mentés…',
  'set.saveChanges': 'Módosítások mentése',
  'set.default': 'Alapértelmezett',
  'set.published': 'Közzétéve',
  'set.draft': 'Piszkozat',
  'set.publish': 'Közzététel',
  'set.unpublish': 'Közzététel visszavonása',
  'set.deleteForm': 'Űrlap törlése',
  'set.description': 'Leírás',
  'set.relationshipSource': 'Kapcsolat forrása',
  'set.dependsOn': 'Függ ettől: {field}',
  'set.deleteFormTitle': 'Törli: „{name}”?',
  'set.deleteFormDescription': 'Ez a jegyűrlap és konfigurációja véglegesen törlődik.',
  'set.formIdRequired': 'Az űrlap azonosítója kötelező.',
  'set.formNotFound': 'A jegyűrlap nem található.',
  'set.tf.removeOption': '{label} eltávolítása',
  'set.tf.noOptions': 'Még nincsenek meghatározott lehetőségek.',
  'set.tf.addOptionPlaceholder': 'Lehetőség hozzáadása...',
  'set.tf.add': 'Hozzáadás',
  'set.tf.dependsOnField': 'Függ ettől a mezőtől',
  'set.tf.selectParent': '— Szülőmező kiválasztása —',
  'set.tf.parentHelp': 'A szülő legördülő mező, amelynek kiválasztott értéke határozza meg ennek a mezőnek az elérhető lehetőségeit.',
  'set.tf.optionMappings': 'Lehetőség-hozzárendelések',
  'set.tf.savingParen': '(mentés...)',
  'set.tf.mappingsError': 'A hozzárendelések betöltése nem sikerült',
  'set.tf.archivedParen': ' (archivált)',
  'set.tf.mappedCount': '{count} hozzárendelve',
  'set.tf.saveFirst': 'A lehetőség-hozzárendelések konfigurálásához először mentse a mezőt.',
  'set.tf.newField': 'Új {type}',
  'set.tf.pageDescription': 'Az importált meződefiníciók, a láthatóság, a kötelezőségi szabályok és a jegyűrlapok által használt sorrend kezelése.',
  'set.tf.addField': 'Mező hozzáadása',
  'set.tf.addFieldHelp': 'Húzzon egy típust a mezőlistába, vagy használja a Hozzáadás gombot.',
  'set.tf.addType': '{type} hozzáadása',
  'set.tf.registry': 'Mezőnyilvántartás',
  'set.tf.savingOrder': 'Sorrend mentése…',
  'set.tf.searchAria': 'Jegymezők keresése',
  'set.tf.searchPlaceholder': 'Keresés név vagy kulcs alapján...',
  'set.tf.filterAria': 'Szűrés mezőtípus szerint',
  'set.tf.allTypes': 'Minden mezőtípus',
  'set.tf.emptyFirstTitle': 'Adja hozzá az első jegymezőt',
  'set.tf.emptyFirstDesc': 'Húzzon egy mezőtípust a palettáról, vagy a Hozzáadás gombbal hozzon létre egyet.',
  'set.tf.emptyFilterTitle': 'Nincs a szűrőknek megfelelő mező',
  'set.tf.emptyFilterDesc': 'Próbáljon más keresési kifejezést, vagy bővítse a mezőtípus-szűrőt.',
  'set.tf.archived': 'Archivált',
  'set.tf.dependent': 'Függő',
  'set.tf.customerVisible': 'Ügyfél számára látható',
  'set.tf.internal': 'Belső',
  'set.tf.configuration': 'Mező konfigurációja',
  'set.tf.selectTitle': 'Válasszon mezőt a konfiguráláshoz',
  'set.tf.selectDesc': 'Válasszon egy mezőt a nyilvántartásból a címkéi, szabályai és láthatósága szerkesztéséhez.',
  'set.tf.externalId': 'Külső azonosító: {value}',
  'set.tf.sourceRenderer': 'Forrás: {source} · Megjelenítő: {renderer}',
  'set.tf.optionSource': 'Lehetőségek forrása: {value}',
  'set.tf.dependsOnKey': 'Függ ettől: {value}',
  'set.tf.internalLabel': 'Belső címke',
  'set.tf.customerLabel': 'Ügyfélcímke',
  'set.tf.relationshipHelp': 'Meghatározza, honnan kérdezi le a rendszer a keresési értékeket futásidőben.',
  'set.tf.validationVisibility': 'Érvényesítés és láthatóság',
  'set.tf.requiredAgents': 'Kötelező az ügynököknek',
  'set.tf.requiredCustomers': 'Kötelező az ügyfeleknek',
  'set.tf.requiredClosure': 'Kötelező lezáráskor',
  'set.tf.displayedCustomers': 'Megjelenik az ügyfeleknek',
  'set.tf.customersEdit': 'Az ügyfelek szerkeszthetik',
  'set.tf.customersFilter': 'Az ügyfelek szűrhetnek rá',
  'set.tf.active': 'Aktív',
  'set.tf.dropdownOptions': 'Legördülő lista lehetőségei ({count})',
  'set.tf.archiveTitle': 'Archiválja: „{name}”?',
  'set.tf.archiveDesc': 'A mező inaktívvá válik, és nem lesz elérhető új jegyekhez. A meglévő jegyadatok megmaradnak.',
  'set.tf.archiveField': 'Mező archiválása',
  'set.tf.alreadyArchived': 'Már archiválva',
  'set.tf.archivedNote': 'Az archivált mezők a korábbi értékekhez továbbra is elérhetők maradnak.',
  'set.tfm.systemUser': 'Rendszer',
  'set.tfm.untitled': 'Névtelen űrlap',
  'set.tfm.pageDescription': 'Hozzon létre újrafelhasználható űrlapokat, és válassza ki, mely importált mezőket használhatják az ügynökök és az ügyfelek.',
  'set.tfm.newForm': 'Új űrlap',
  'set.tfm.creating': 'Létrehozás…',
  'set.tfm.allForms': 'Minden űrlap',
  'set.tfm.configuredOne': '{count} konfigurált űrlap',
  'set.tfm.configuredMany': '{count} konfigurált űrlap',
  'set.tfm.filter': 'Szűrő',
  'set.tfm.searchAria': 'Jegyűrlapok keresése',
  'set.tfm.searchPlaceholder': 'Űrlapok keresése…',
  'set.tfm.status': 'Állapot',
  'set.tfm.allStatuses': 'Minden állapot',
  'set.tfm.emptyFilterTitle': 'Nincs a szűrőknek megfelelő űrlap',
  'set.tfm.emptyFilterDesc': 'Próbáljon más keresési kifejezést, vagy bővítse az állapotszűrőt.',
  'set.tfm.emptyFirstTitle': 'Hozza létre az első jegyűrlapot',
  'set.tfm.emptyFirstDesc': 'Hozzon létre egy űrlapot az importált mezők konfigurálásának megkezdéséhez.',
  'set.tfm.createFirst': 'Hozza létre az első űrlapot',
  'set.tfm.colName': 'Név',
  'set.tfm.colCreatedAt': 'Létrehozva',
  'set.tfm.colUpdatedBy': 'Utoljára frissítette',
  'set.tfm.colUpdatedAt': 'Utoljára frissítve',
  'set.tfm.colPortals': 'Társított portálok',
  'set.tfm.colActions': 'Műveletek',
  'set.tfm.notConfigured': 'Nincs konfigurálva',
  'set.tfm.actionsFor': 'Műveletek: {name}',
  'set.tfm.editForm': 'Űrlap szerkesztése',
  'set.tb.section.default.title': 'Alapértelmezett mezők',
  'set.tb.section.default.desc': 'A forrásrendszerből importált alapvető támogatási munkafolyamat-mezők.',
  'set.tb.section.custom.title': 'Egyéni mezők',
  'set.tb.section.custom.desc': 'A támogatási folyamathoz konfigurált további mezők.',
  'set.tb.section.nested.title': 'Beágyazott mezők',
  'set.tb.section.nested.desc': 'Függő mezők, amelyek lehetőségei egy szülőmezőt követnek.',
  'set.tb.discardTitle': 'Elveti a mentetlen módosításokat?',
  'set.tb.discardDesc': 'A jegyűrlapon végzett módosításai nem lettek elmentve.',
  'set.tb.leave': 'Kilépés mentés nélkül',
  'set.tb.nameRequired': 'Az űrlap neve kötelező.',
  'set.tb.saved': 'Űrlap mentve.',
  'set.tb.nowPublished': 'Űrlap közzétéve.',
  'set.tb.nowUnpublished': 'Az űrlap közzététele visszavonva.',
  'set.tb.admin': 'Adminisztráció',
  'set.tb.builder': 'Szerkesztő',
  'set.tb.titleAria': 'Űrlap címe',
  'set.tb.defaultLocked': 'Alapértelmezett / zárolt',
  'set.tb.previewPortal': 'Előnézet a portálon',
  'set.tb.configureTitle': 'Konfigurálja az űrlapon szereplő mezőket.',
  'set.tb.configureDesc': 'A módosítások a Módosítások mentése gombra kattintva kerülnek a támogatási központ adatbázisába. A kötelező mezők engedélyezve maradnak.',
  'set.tb.formDetails': 'Űrlap részletei',
  'set.tb.formDetailsHelp': 'Használjon egyértelmű leírást, hogy az adminisztrátorok tudják, mikor használják ezt az űrlapot.',
  'set.tb.descPlaceholder': 'Írja le, mikor kell ezt az űrlapot használni…',
  'set.tb.importedFields': 'Importált mezők',
  'set.tb.importedHelp': 'Húzással átrendezheti a mezőket. A kapcsolóval felveheti vagy kizárhatja a mezőt az űrlapról.',
  'set.tb.noneInSection': 'Ebben a szakaszban nincsenek importált mezők.',
  'set.tb.dragReorder': 'Húzza az átrendezéshez',
  'set.tb.required': 'Kötelező',
  'set.tb.nested': 'Beágyazott',
  'set.tb.enableField': '{label} engedélyezése',
  'set.tb.enabled': 'Engedélyezve',
  'set.tb.disabled': 'Letiltva',
  'set.tb.emptyTitle': 'Még nincsenek konfigurálandó mezők',
  'set.tb.emptyDesc': 'Importáljon jegymezőket az űrlap felépítésének megkezdéséhez.',
  'set.tb.deleting': 'Törlés…',
  'set.tp.loadError': 'Az űrlap előnézetének betöltése nem sikerült.',
  'set.tp.preview': 'Előnézet',
  'set.tp.customerPreview': 'Ügyfél által látott előnézet',
  'set.tp.backToBuilder': 'Vissza a szerkesztőhöz',
  'set.tp.modeTitle': 'Előnézeti mód',
  'set.tp.modeDesc': 'Ez egy nem küldő előnézet. Minden engedélyezett mező a mentett űrlapsorrendben jelenik meg.',
  'set.tp.emptyTitle': 'Még nincsenek engedélyezett mezők',
  'set.tp.emptyDesc': 'Engedélyezzen mezőket az űrlapszerkesztőben, hogy megjelenjenek ebben az előnézetben.',

  'por.error.generic': 'A kérés teljesítése nem sikerült.',
  'por.error.requestNotFound': 'A kérés nem található.',
  'por.error.formUnavailable': 'A kérésűrlap nem érhető el.',
  'por.error.articleNotFound': 'A cikk nem található.',
  'por.error.selectRating': 'Kérjük, válasszon 1 és 5 közötti értékelést.',
  'por.tab.all': 'Összes',
  'por.list.title': 'Támogatási kéréseim',
  'por.list.description': 'Kövesse nyomon kéréseit, és válaszoljon a támogatási csapatnak.',
  'por.list.newRequest': 'Új kérés',
  'por.list.knowledgeBase': 'Tudásbázis',
  'por.list.filterByStatus': 'Kérések szűrése állapot szerint',
  'por.list.searchPlaceholder': 'Keresés tárgy alapján…',
  'por.list.count': '{count} kérés',
  'por.list.countOne': '{count} kérés',
  'por.list.emptyFilteredTitle': 'Nincs a nézetnek megfelelő kérés',
  'por.list.emptyTitle': 'Még nincsenek kérések',
  'por.list.emptyFilteredDescription': 'Próbálja az Összes fület vagy más keresési kifejezést.',
  'por.list.emptyDescription': 'Küldjön be egy kérést, és a támogatási csapat felveszi.',
  'por.list.submitFirst': 'Küldje be az első kérését',
  'por.col.request': 'Kérés',
  'por.col.subject': 'Tárgy',
  'por.col.status': 'Állapot',
  'por.col.priority': 'Prioritás',
  'por.col.created': 'Létrehozva',
  'por.detail.myRequests': 'Kéréseim',
  'por.detail.reopen': 'Kérés újranyitása',
  'por.detail.attachments': 'Mellékletek',
  'por.detail.download': 'Letöltés',
  'por.detail.conversation': 'Beszélgetés',
  'por.detail.noReplies': 'Még nincsenek válaszok',
  'por.detail.noRepliesHint': 'Adjon hozzá egy választ alább, és a támogatási csapat felveszi.',
  'por.detail.reply': 'Válasz',
  'por.detail.replyPlaceholder': 'Írjon választ',
  'por.detail.sending': 'Küldés…',
  'por.detail.sendReply': 'Válasz küldése',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': '{name} eltávolítása',
  'por.submit.newRequest': 'Új kérés',
  'por.submit.defaultTitle': 'Támogatási kérés beküldése',
  'por.submit.intro': 'Töltse ki az alábbi mezőket, és küldje be a kérését.',
  'por.submit.subjectRequired': 'A tárgy megadása kötelező',
  'por.submit.descriptionRequired': 'A leírás megadása kötelező',
  'por.submit.attachments': 'Mellékletek',
  'por.submit.submitting': 'Beküldés…',
  'por.submit.submit': 'Kérés beküldése',
  'por.kb.portal': 'Portál',
  'por.kb.title': 'Tudásbázis',
  'por.kb.description': 'Keressen választ, mielőtt kérést küld be.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Keresési találatok',
  'por.kb.searchPlaceholder': 'Cikkek keresése',
  'por.kb.emptyTitle': 'Még nincs közzétett cikk',
  'por.kb.emptyDescription': 'Küldjön be egy kérést, és a támogatási csapat közvetlenül segít.',
  'por.kb.noFolders': 'Nincsenek mappák',
  'por.kb.articles': '{count} cikk',
  'por.kb.articlesOne': '{count} cikk',
  'por.kb.noMatch': 'Nincs cikk a következőre: „{query}”',
  'por.kb.folderEmpty': 'Ebben a mappában még nincs cikk',
  'por.kb.noMatchHint': 'Próbáljon rövidebb keresési kifejezést, vagy küldjön be inkább egy kérést.',
  'por.kb.folderEmptyHint': 'Böngésszen egy másik mappában, vagy küldjön be inkább egy kérést.',
  'por.kb.submitRequest': 'Kérés beküldése',
  'por.kb.views': '{count} megtekintés',
  'por.kb.thanks': 'Köszönjük a visszajelzését!',
  'por.kb.helpful': 'Hasznos volt ez?',
  'por.kb.yes': 'Igen',
  'por.kb.no': 'Nem',
  'por.csat.thanksTitle': 'Köszönjük a visszajelzését',
  'por.csat.thanksBody': 'A válasza rögzítésre került.',
  'por.csat.title': 'Hogyan teljesítettünk?',
  'por.csat.request': '#{number}. kérés: {subject}',
  'por.csat.rating': 'Értékelés',
  'por.csat.stars': '{count} csillag',
  'por.csat.comment': 'Megjegyzés',
  'por.csat.submit': 'Visszajelzés beküldése',
  'agents.tempPassword.title': 'Ideiglenes jelszó',
  'agents.tempPassword.help': 'Állítson be ideiglenes jelszót ehhez az ügynökhöz. A következő bejelentkezéskor új jelszót kell választania. Legalább 12 karakter.',
  'agents.tempPassword.button': 'Ideiglenes jelszó beállítása',
  'agents.tempPassword.saving': 'Beállítás…',
  'agents.tempPassword.error': 'Az ideiglenes jelszót nem sikerült beállítani.',
  'ui.showPassword': 'Jelszó megjelenítése',
  'ui.hidePassword': 'Jelszó elrejtése',
  'dashboard.awaitingResolutionConfirmation': 'Megoldás megerősítésére vár',
  'dashboard.awaitingUserReply': 'Felhasználói válaszra vár',
  'dashboard.changeRequests': 'Változtatási kérelmek',
  'agents.tempPassword.successEmailed': 'Az ideiglenes jelszó beállítva, és e-mailben elküldve az ügynöknek.',
  'agents.tempPassword.successNotEmailed': 'Az ideiglenes jelszó beállítva, de az e-mailt nem sikerült elküldeni. Biztonságos csatornán ossza meg a jelszót az ügynökkel.',
} as const;

export default hu;
